import React, { createContext, useContext, useMemo, useState, useEffect } from 'react'

const I18nContext = createContext(null)

const messages = {
  'pt-BR': {
    'auth.login.badge': 'ACESSO RESTRITO',
    'auth.signup.badge': 'NOVO MEMBRO',
    'auth.subtitle': 'O COFRE DOS COLECIONADORES',
    'auth.form.fullName': 'Nome Completo',
    'auth.form.fullName.placeholder': 'Seu nome completo',
    'auth.form.country': 'País',
    'auth.form.cpf': 'CPF/CNPJ',
    'auth.form.cpf.placeholder': '000.000.000-00',
    'auth.form.rg': 'RG',
    'auth.form.rg.placeholder': '00.000.000-0',
    'auth.form.taxId': 'Tax ID / National ID',
    'auth.form.taxId.placeholder': 'A1B2C3',
    'auth.form.taxId.hint': '📝 Documento nacional (Tax ID)',
    'auth.form.taxId.invalid': 'Documento inválido',
    'auth.form.taxId.invalidDesc': 'Informe um Tax ID / National ID válido.',
    'auth.form.passport': 'Passport / ID Number',
    'auth.form.passport.placeholder': 'X1234567',
    'auth.form.passport.hint': '📝 Documento (Passaporte/ID)',
    'auth.form.passport.invalid': 'Documento inválido',
    'auth.form.passport.invalidDesc': 'Informe um Passport / ID Number válido.',
    'auth.form.email': 'Email de Acesso',
    'auth.form.password': 'Senha Criptografada',
    'auth.form.remember': 'LEMBRE-SE DE MIM',
    'auth.form.forgot': 'ESQUECI A SENHA',
    'auth.login.submit': 'ENTRAR NO COFRE',
    'auth.signup.submit': 'CRIAR CREDENCIAIS',
    'auth.login.processing': 'ENTRANDO...',
    'auth.signup.processing': 'CRIANDO...',
    'auth.login.toggle': 'NÃO POSSUI CONTA? CADASTRE-SE',
    'auth.signup.toggle': 'JÁ POSSUI CONTA? ENTRE',
    'country.br': 'Brasil',
    'country.us': 'Estados Unidos',
    'country.ca': 'Canadá',
    'country.gb': 'Reino Unido',
    'country.pt': 'Portugal',
    'country.es': 'Espanha',
    'country.fr': 'França',
    'country.de': 'Alemanha',
    'country.ar': 'Argentina',
    'country.mx': 'México',
    'country.other': 'Outro',
    'notFound.title': 'Ops! Esse disco riscou',
    'notFound.description': 'A página que você procura não foi encontrada no catálogo',
    'notFound.tip': 'Parece que essa página está mais rara que um Beatles original de 1963.',
    'notFound.ctaBack': 'Voltar',
    'notFound.ctaExplore': 'Explorar Catálogo',
    'notFound.ctaPortal': 'Portal',
    'nav.explore': 'Explorar',
    'nav.grooveflix': 'Grooveflix',
    'nav.plans': 'Planos',
    'nav.myItems': 'Meu Acervo',
    'nav.swaps': 'Trocas',
    'nav.community': 'Comunidade',
    'nav.search.placeholder': 'Buscar CDs...',
    'nav.search.submit': 'Buscar',
    'nav.dropdown.profile': 'Meu Perfil',
    'nav.dropdown.balance': 'Meu Saldo',
    'nav.dropdown.settings': 'Configurações',
    'nav.dropdown.logout': 'Sair',
    'nav.dropdown.language': 'Idioma',
    'nav.admin.bank': 'Banco RareGroove',
    'nav.admin.profiles': 'Gestor de Perfis',
    'myItems.title.prefix': 'Meu',
    'myItems.title.highlight': 'Acervo',
    'myItems.subtitle': 'Gestão de venda e troca',
    'myItems.actions.add': 'Anunciar CD',
    'myItems.empty': 'Nenhum item anunciado.',
    'myItems.status.negotiation': 'EM NEGOCIAÇÃO',
    'myItems.status.sold': 'VENDIDO',
    'myItems.badge.sale': 'Venda',
    'myItems.badge.swap': 'Troca',
    'myItems.toast.loadError.title': 'ERRO AO CARREGAR',
    'myItems.toast.loadError.desc': 'Não foi possível carregar seu acervo',
    'myItems.toast.invalidConfirm.title': 'CONFIRMAÇÃO INVÁLIDA',
    'myItems.toast.invalidConfirm.desc': 'Digite EXCLUIR para confirmar',
    'myItems.toast.deleteBlocked.title': 'EXCLUSÃO BLOQUEADA',
    'myItems.toast.deleteBlocked.desc': 'Itens vendidos só podem ser excluídos pelo administrador.',
    'myItems.toast.deleted.title': 'ITEM REMOVIDO',
    'myItems.toast.deleted.desc': 'O item foi excluído do seu acervo',
    'myItems.toast.deleteError.title': 'ERRO AO DELETAR',
    'myItems.toast.deleteError.desc': 'Não foi possível remover o item. Verifique se você tem permissão.',
    'myItems.errors.notAuthenticated': 'Usuário não autenticado',
    'myItems.errors.fkBlocked': 'Este item não pode ser excluído pois possui histórico de vendas ou trocas.',
    'myItems.delete.confirmWord': 'EXCLUIR',
    'myItems.deleteModal.title': 'CONFIRMAR EXCLUSÃO',
    'myItems.deleteModal.subtitle': 'Esta ação não pode ser desfeita',
    'myItems.deleteModal.itemLabel': 'Item a ser excluído',
    'myItems.deleteModal.typePrefix': 'Digite',
    'myItems.deleteModal.typeSuffix': 'para confirmar',
    'myItems.actions.cancel': 'Cancelar',
    'myItems.actions.delete': 'Excluir Item',
    'addItem.title.new': 'ANUNCIAR NOVO ITEM',
    'addItem.title.edit': 'EDITAR RELÍQUIA',
    'addItem.fields.title': 'Título do Álbum',
    'addItem.fields.artist': 'Artista / Banda',
    'addItem.fields.price': 'Preço (R$)',
    'addItem.fields.condition': 'Estado',
    'addItem.fields.coverUrl': 'URL da Capa do Álbum',
    'addItem.placeholders.coverUrl': 'https://...',
    'addItem.fields.allowSale': 'Disponível para Venda',
    'addItem.fields.allowSwap': 'Disponível para Troca',
    'addItem.fields.realPhoto': 'Foto Real da Relíquia',
    'addItem.upload.selectFile': 'Clique para selecionar arquivo',
    'addItem.actions.publish': 'AUTENTICAR E PUBLICAR',
    'addItem.actions.save': 'SALVAR ALTERAÇÕES',
    'addItem.condition.MINT': 'MINT (Novo)',
    'addItem.condition.NM': 'Near Mint',
    'addItem.condition.VG_PLUS': 'Very Good+',
    'addItem.condition.VG': 'Very Good',
    'addItem.toast.created.title': 'RELÍQUIA CADASTRADA!',
    'addItem.toast.updated.title': 'ALTERAÇÕES SALVAS!',
    'addItem.toast.error.title': 'ERRO',
    'addItem.toast.error.desc': 'Não foi possível salvar o item.',
    'addItem.errors.notAuthenticated': 'Usuário não autenticado',
    'wishlist.modal.title.add': 'Adicionar à Wishlist',
    'wishlist.modal.title.edit': 'Editar Desejo',
    'wishlist.modal.fields.itemName': 'Nome do Item',
    'wishlist.modal.fields.artist': 'Artista (opcional)',
    'wishlist.modal.fields.maxPrice': 'Preço Máximo (opcional)',
    'wishlist.modal.fields.category': 'Categoria (opcional)',
    'wishlist.modal.fields.description': 'Observações (opcional)',
    'wishlist.modal.placeholders.itemName': 'Ex: Dark Side of the Moon, Michael Jackson...',
    'wishlist.modal.placeholders.artist': 'Ex: Pink Floyd, Queen...',
    'wishlist.modal.placeholders.maxPrice': 'Ex: 150.00',
    'wishlist.modal.placeholders.description': 'Ex: Preferência por primeira prensagem, edição japonesa...',
    'wishlist.modal.hints.itemName': 'Use palavras-chave para aumentar as chances de match',
    'wishlist.modal.hints.maxPrice': 'Deixe vazio para receber todos os matches',
    'wishlist.modal.errors.missingItemName': 'Por favor, informe o nome do item desejado',
    'wishlist.category.all': 'Todas as categorias',
    'wishlist.category.Novo': 'Novo',
    'wishlist.category.Seminovo': 'Seminovo',
    'wishlist.category.Usado': 'Usado',
    'wishlist.category.Colecionador': 'Colecionador',
    'wishlist.actions.cancel': 'Cancelar',
    'wishlist.actions.saving': 'Salvando...',
    'wishlist.actions.update': 'Atualizar',
    'wishlist.actions.add': 'Adicionar',
    'wishlist.actions.pause': 'Pausar',
    'wishlist.actions.activate': 'Ativar',
    'wishlist.actions.edit': 'Editar',
    'wishlist.actions.remove': 'Remover',
    'wishlist.errors.notAuthenticated': 'Usuário não autenticado',
    'wishlist.toast.created.title': '✨ Desejo adicionado à lista!',
    'wishlist.toast.created.desc': 'Você será notificado quando encontrarmos um match',
    'wishlist.toast.updated.title': '✨ Desejo atualizado!',
    'wishlist.toast.error.title': 'Erro ao salvar desejo',
    'wishlist.toast.error.desc': 'Não foi possível salvar o desejo.',
    'wishlist.toast.removed.title': 'Desejo removido',
    'wishlist.toast.removeError.title': 'Erro ao remover desejo',
    'wishlist.toast.paused.title': 'Desejo pausado',
    'wishlist.toast.activated.title': 'Desejo ativado',
    'wishlist.toast.toggleError.title': 'Erro ao atualizar desejo',
    'wishlist.card.confirmRemove': 'Deseja remover este desejo da lista?',
    'wishlist.card.artistLabel': 'Artista:',
    'wishlist.card.maxPriceLabel': 'Até:',
    'wishlist.card.categoryLabel': 'Categoria:',
    'wishlist.card.addedAt': 'Adicionado em',
    'wishlist.card.status.searching': 'Buscando',
    'wishlist.card.status.paused': 'Pausado',
    'wishlist.empty.title': 'Sua Wishlist está vazia',
    'wishlist.empty.desc': 'Adicione itens raros que você está procurando e seja notificado automaticamente quando eles aparecerem no acervo!',
    'wishlist.empty.addFirst': 'Adicionar Primeiro Desejo',
    'portal.hero.badge': 'Portal de Transparência & Conformidade Legal',
    'portal.hero.subtitle1': 'O maior marketplace de CDs raros da América Latina',
    'portal.hero.subtitle2': 'Transparência, segurança e conformidade legal total',
    'portal.sidebar.title': 'Documentos',
    'portal.section.sobre': 'Sobre a Plataforma',
    'portal.section.imortalidade': 'A Jornada da Imortalidade',
    'portal.section.termos': 'Termos de Serviço',
    'portal.section.privacidade': 'Privacidade & LGPD',
    'portal.section.comunidade': 'Política da Comunidade',
    'portal.section.envios': 'Política de Envios',
    'portal.section.dmca': 'DMCA & Direitos Autorais'
    ,
    'portal.immortality.intro': 'Grooveflix nasce do ritual de preservar o que é raro. Aqui, você transforma mídia física em memória eterna: extração bit‑perfect, validação do rip e armazenamento no Sarcófago Digital para streaming Hi‑Fi.',
    'portal.immortality.step1.title': 'Passo 1: A Extração Perfeita',
    'portal.immortality.step1.body': 'Use o Exact Audio Copy (EAC) em modo seguro para garantir cópias bit‑perfect. O log do EAC é a prova do ritual.',
    'portal.immortality.step1.cta': 'Baixar Exact Audio Copy Oficial',
    'portal.immortality.step2.title': 'Passo 2: O Ritual de Upload',
    'portal.immortality.step2.body': 'Envie o .flac e o arquivo .log do EAC para validação do Gemini. Ele confirma integridade, offsets e qualidade do rip.',
    'portal.immortality.step2.note': 'FLAC + LOG',
    'portal.immortality.step3.title': 'Passo 3: A Eternidade',
    'portal.immortality.step3.body': 'Depois de validado, o CD vive no Sarcófago Digital (Backblaze B2) e pode ser ouvido no Grooveflix com estética Hi‑Fi.',
    'portal.immortality.plansCta': 'Planos',
    'portal.immortality.infobox': 'MVP: a interface do Grooveflix já nasce pronta. A automação de upload/validação e o pipeline B2→Cloudflare entram na próxima fase.',
    'grooveflix.badge': 'HI‑FI STREAMING',
    'grooveflix.subtitle': 'O sarcófago digital do colecionador. Streaming e curadoria em estética Hi‑Fi.',
    'grooveflix.loading': 'Carregando...',
    'grooveflix.albums': 'álbuns',
    'grooveflix.rows.continue': 'Continuar Ouvindo',
    'grooveflix.rows.recent': 'Recém Imortalizados',
    'grooveflix.rows.jp': 'Prensagens Japonesas',
    'grooveflix.rows.br': 'Grooves Brasileiros Esquecidos',
    'plans.badge': 'GUARDIÕES DO SARCOFÁGO',
    'plans.title': 'Assinaturas',
    'plans.subtitle': 'Escolha seu nível de Guardião para imortalizar e ouvir sua coleção com estética Hi‑Fi.',
    'plans.recommended': 'Recomendado',
    'plans.preview': 'Ver Grooveflix',
    'plans.note.title': 'Nota',
    'plans.note.body': 'O checkout de pagamento e a validação automática de uploads entram na próxima fase. Por enquanto, esta tela define o plano escolhido e libera a navegação do Grooveflix.',
    'plans.saved.title': 'PLANO SELECIONADO',
    'plans.saved.desc': 'Checkout de assinatura entra na próxima etapa.',
    'plans.selectFirst': 'Selecione um plano para continuar.',
    'plans.restricted.badge': 'ACESSO RESTRITO',
    'plans.restricted.title': 'A Catraca Bloqueou o Sarcófago',
    'plans.restricted.body': 'Para entrar no Grooveflix, ative um plano Guardião com assinatura ativa.',
    'plans.restricted.close': 'Ver Planos',
    'plans.restricted.cta': 'Ativar Keeper',
    'plans.digger.title': 'DIGGER',
    'plans.digger.price': 'Grátis',
    'plans.digger.badge': 'Entrada',
    'plans.digger.f1': 'Acesso ao Marketplace',
    'plans.digger.f2': '5 imortalizações de teste',
    'plans.digger.f3': 'Biblioteca pessoal (limitada)',
    'plans.digger.cta': 'Entrar no Groove',
    'plans.keeper.title': 'KEEPER',
    'plans.keeper.price': 'Pro',
    'plans.keeper.badge': 'Prata',
    'plans.keeper.f1': 'Até 100 CDs imortalizados',
    'plans.keeper.f2': 'Streaming Hi‑Fi (Mobile)',
    'plans.keeper.f3': 'Selo Prata no perfil',
    'plans.keeper.cta': 'Virar Keeper',
    'plans.high.title': 'HIGH GUARDIAN',
    'plans.high.price': 'Elite',
    'plans.high.badge': 'Ouro Neon',
    'plans.high.f1': 'CDs ilimitados',
    'plans.high.f2': 'Streaming Bit‑Perfect',
    'plans.high.f3': 'Ouvir itens públicos da comunidade',
    'plans.high.f4': 'Selo Ouro com brilho neon',
    'plans.high.cta': 'Virar Guardian',
    'checkout.subscription.badge': 'CHECKOUT GROOVEFLIX',
    'checkout.subscription.title': 'Finalizando seu',
    'checkout.subscription.title2': 'Ritual de Guardião',
    'checkout.subscription.subtitle': 'Confirme o plano e finalize o pagamento. Assim que aprovado, a catraca libera o Sarcófago.',
    'checkout.subscription.planLabel': 'Plano Selecionado',
    'checkout.subscription.total': 'Total',
    'checkout.subscription.gateway': 'Método de Pagamento',
    'checkout.subscription.cta': 'Confirmar e Pagar',
    'checkout.subscription.back': 'Voltar',
    'checkout.subscription.noteTitle': 'Aviso',
    'checkout.subscription.noteBody': 'A liberação do acesso ocorre automaticamente após a confirmação do gateway. Se demorar alguns segundos, o sistema faz sincronização via webhook.',
    'checkout.subscription.success.title': 'PAGAMENTO CONFIRMADO',
    'checkout.subscription.success.desc': 'Liberando acesso ao Sarcófago...',
    'checkout.subscription.error.title': 'ERRO NO PAGAMENTO',
    'checkout.subscription.error.desc': 'Tente novamente.',
    'checkout.subscription.unlocked.badge': 'Acesso Liberado',
    'checkout.subscription.unlocked.badgePending': 'Liberando...',
    'checkout.subscription.unlocked.badgeFail': 'Sincronização Pendente',
    'checkout.subscription.unlocked.title': 'Sarcófago',
    'checkout.subscription.unlocked.title2': 'Aberto',
    'checkout.subscription.unlocked.pendingTitle': 'Acesso',
    'checkout.subscription.unlocked.pendingTitle2': 'Sendo Liberado',
    'checkout.subscription.unlocked.failTitle': 'Quase lá',
    'checkout.subscription.unlocked.desc': 'Sua assinatura foi ativada. Redirecionando para o Grooveflix…',
    'checkout.subscription.unlocked.pendingDesc': 'Estamos aguardando a confirmação final do gateway. Isso pode levar alguns segundos.',
    'checkout.subscription.unlocked.failDesc': 'O webhook ainda está sincronizando. Aguarde alguns segundos e tente novamente.',
    'checkout.subscription.unlocked.cta': 'Entrar no Grooveflix',
    'checkout.subscription.unlocked.retry': 'Recarregar',
    'checkout.subscription.unlocked.plans': 'Ver Planos',
    'portal.terms.lastUpdate': 'Última atualização: 12 de Fevereiro de 2026',
    'portal.terms.warningTitle': '⚠️ OBRIGAÇÃO LEGAL:',
    'portal.terms.warningBody': 'Ao usar RAREGROOVE como vendedor, você declara que: (1) Os CDs são originais, (2) Você tem direito legal de vendê-los, (3) Suas descrições são honestas e precisas. Falsa declaração resulta em banimento permanente + ação legal.',
    'portal.terms.section1.title': '1. Aceitação dos Termos',
    'portal.terms.section1.body': 'Ao acessar e utilizar o Marketplace RAREGROOVE, você concorda em estar vinculado por estes Termos de Serviço. Se você não concorda com qualquer parte destes termos, você não está autorizado a usar o Serviço.'
    ,
    'portal.terms.section2.title': '2. Direitos do Comprador',
    'portal.terms.section2.items.custody': 'Custódia de pagamento: Seu dinheiro fica com RAREGROOVE por até 7 dias — nunca vai direto ao vendedor antes da confirmação',
    'portal.terms.section2.items.authenticity': 'Garantia de autenticidade: Se o CD for falso, recebe 100% de volta sem precisar devolver',
    'portal.terms.section2.items.condition': 'Garantia de condição: Se a condição não corresponder, pode devolver em 7 dias',
    'portal.terms.section2.items.tracking': 'Rastreamento obrigatório: Todo CD tem rastreio com cobertura automática',
    'portal.terms.section2.items.mediation': 'Mediação: Se discordar do vendedor, RAREGROOVE arbitra em máximo 16 dias',
    'portal.terms.section3.title': '3. Responsabilidades do Vendedor',
    'portal.terms.section3.items.scale': 'Descrever condição REAL do CD usando escala Discogs (Mint, NM, VG+, VG, Good, Fair)',
    'portal.terms.section3.items.photos': 'Mínimo 3 fotos: frente, verso, disco — mostrando condição real',
    'portal.terms.section3.items.defects': 'Revelar TODOS os defeitos conhecidos na descrição',
    'portal.terms.section3.items.shippingTime': 'Enviar o CD em até 2 dias após confirmação da venda',
    'portal.terms.section3.items.tracking': 'Envio com rastreamento é obrigatório',
    'portal.terms.section3.items.counterfeit': 'CDs falsificados = banimento permanente + ação legal',
    'portal.terms.section4.title': '4. Sistema de Custódia (Escrow)',
    'portal.terms.section4.timeline.day1': 'Dia 1',
    'portal.terms.section4.timeline.day1.desc': 'Comprador paga via PIX',
    'portal.terms.section4.timeline.days1_3': 'Dias 1-3',
    'portal.terms.section4.timeline.days1_3.desc': 'Vendedor envia CD com rastreio',
    'portal.terms.section4.timeline.days4_8': 'Dias 4-8',
    'portal.terms.section4.timeline.days4_8.desc': 'Comprador recebe o CD',
    'portal.terms.section4.timeline.day8': 'Dia 8',
    'portal.terms.section4.timeline.day8.desc': 'Comprador confirma recebimento',
    'portal.terms.section4.timeline.days9_10': 'Dias 9-10',
    'portal.terms.section4.timeline.days9_10.desc': 'Vendedor recebe o dinheiro',
    'portal.terms.section5.title': '5. Resolução de Disputas',
    'portal.terms.section5.steps.1': 'Contate o vendedor via chat privado da plataforma (aguarde 48h)',
    'portal.terms.section5.steps.2': 'Se não resolver, abra uma disputa dentro de 7 dias',
    'portal.terms.section5.steps.3': 'Envie evidências: fotos, screenshots, rastreamento',
    'portal.terms.section5.steps.4': 'Especialista RAREGROOVE analisa e arbitra em máximo 16 dias',
    'portal.terms.section5.steps.5': 'Compradores que abrem múltiplas disputas falsas levam ban permanente',
    'portal.terms.section6.title': '6. Terminação de Conta',
    'portal.terms.section6.lead': 'RAREGROOVE reserva o direito de:',
    'portal.terms.section6.items.suspend': 'Suspender conta por violação de Termos',
    'portal.terms.section6.items.retain': 'Reter dinheiro em custódia durante investigação de fraude',
    'portal.terms.section6.items.ban': 'Banir permanentemente por: falsificação, fraude, abuso, violação DMCA',
    'portal.terms.section6.items.report': 'Relatar atividade criminosa às autoridades competentes',
    'portal.terms.section7.title': '7. Disposições Finais',
    'portal.terms.section7.body': 'Lei Aplicável: Leis da República Federal do Brasil. Para disputas legais, foro competente será definido conforme aplicável. RAREGROOVE pode modificar estes Termos com comunicação prévia por email.'
    ,
    'portal.hero.pill.lgpd': '✓ Conforme LGPD',
    'portal.hero.pill.dmca': '✓ DMCA Compliant',
    'portal.hero.pill.custody': '✓ Custódia Segura',
    'portal.hero.pill.cdc': '✓ CDC Brasil',
    'portal.privacy.lastUpdate': 'Última atualização: 12 de Fevereiro de 2026 — Em conformidade com a Lei 13.709/2018 (LGPD)',
    'portal.privacy.section.collect.title': 'Informações que Coletamos',
    'portal.privacy.section.collect.what': 'O que coletamos',
    'portal.privacy.section.collect.not': 'O que NÃO coletamos',
    'portal.privacy.collect.items.nameEmail': 'Nome, email e dados de perfil',
    'portal.privacy.collect.items.ip': 'Endereço IP (segurança e prevenção de fraude)',
    'portal.privacy.collect.items.timestamps': 'Timestamps de acesso (login/logout)',
    'portal.privacy.collect.items.ua': 'Navegador, sistema operacional',
    'portal.privacy.collect.items.history': 'Histórico de transações na plataforma',
    'portal.privacy.collect.not.audio': '❌ Conteúdo de arquivos de áudio',
    'portal.privacy.collect.not.biometric': '❌ Dados biométricos',
    'portal.privacy.collect.not.browsing': '❌ Histórico de navegação fora da plataforma',
    'portal.privacy.collect.not.selling': '❌ Não vendemos dados para terceiros',
    'portal.privacy.section.share.title': 'Compartilhamento de Dados',
    'portal.privacy.share.infobox': 'Não compartilhamos dados pessoais com terceiros, exceto quando exigido por lei (avisos DMCA, mandados judiciais), com prestadores de serviço sob acordos de proteção de dados, ou em caso de detecção de atividade criminosa.',
    'portal.privacy.section.rights.title': 'Seus Direitos (LGPD)',
    'portal.privacy.rights.items.access': 'Acesso: Solicitar cópia dos seus dados pessoais',
    'portal.privacy.rights.items.portability': 'Portabilidade: Receber dados em formato estruturado',
    'portal.privacy.rights.items.delete': 'Exclusão: Solicitar exclusão dos seus dados (sujeito a retenção legal)',
    'portal.privacy.rights.items.rectify': 'Retificação: Corrigir informações imprecisas',
    'portal.privacy.rights.items.consent': 'Revogação de consentimento: A qualquer momento',
    'portal.privacy.rights.contactLead': 'Para exercer esses direitos:',
    'portal.privacy.rights.responseTime': 'Prazo de resposta: 30 dias úteis',
    'portal.privacy.section.security.title': 'Segurança de Dados',
    'portal.privacy.security.items.aes': 'Criptografia AES-256 para dados em repouso',
    'portal.privacy.security.items.tls': 'TLS 1.3 em trânsito (comunicação criptografada)',
    'portal.privacy.security.items.isolation': 'Isolamento de dados entre usuários',
    'portal.privacy.security.items.passwords': 'Senhas com hash bcrypt + salt único',
    'portal.privacy.security.items.audit': 'Retenção de dados de auditoria por 7 anos para conformidade legal',
    'portal.community.title': 'Política da Comunidade',
    'portal.community.expected': '✓ Comportamento Esperado',
    'portal.community.prohibited': '✗ Comportamento Proibido',
    'portal.community.expected.items': 'Ser honesto em descrições de produto;Responder mensagens em até 24h;Enviar com rastreamento, bem embalado;Deixar avaliações justas e construtivas;Resolver disputas de forma colaborativa;Usar a plataforma exclusivamente para CDs originais',
    'portal.community.prohibited.items': 'Descrever CDs com condição falsa;Ocultar defeitos nas fotos;Vender CDs falsificados como originais;Pedir para sair da plataforma (WhatsApp, PIX direto);Assediar ou intimidar membros;Criar contas falsas ou falsificar dados',
    'portal.community.scale.title': 'Escala de Condição de CDs (Discogs)',
    'portal.community.scale.items': 'Mint (M)|Ainda lacrado, nunca tocado;Near Mint (NM)|Tocado poucas vezes, praticamente novo;Very Good Plus (VG+)|Pequenos sinais de uso, som perfeito;Very Good (VG)|Sinais de toque, possível clique leve;Good (G)|Mais desgastado, cliques notáveis mas toca;Fair (F)|Muito usado, som pode ser afetado',
    'portal.community.punishments.title': 'Punições por Violação',
    'portal.community.punishments.items': '🔴 CRÍTICO — Banimento Permanente|CD falsificado, fraude intencional, harassment severo, venda de cópias pirateadas;🟠 SÉRIO — Suspensão ou Banimento|Descrição significativamente falsa, não enviar após venda, desaparecimento de conta;🟡 MENOR — Aviso ou Suspensão Curta|Foto copiada, atraso em envio, resposta lenta, tom agressivo no chat',
    'portal.community.appeal.title': 'Direito de Apelo',
    'portal.community.appeal.body': 'Se você foi suspenso/banido injustamente, pode apelar em até 30 dias enviando para raregroovecdseswapsafe@gmail.com com: ID da sua conta, descrição da infração, motivo do apelo e evidências.',
    'portal.community.lead': 'Criamos um espaço seguro, honesto e justo para transações de CDs. Todos os membros devem respeitar estes princípios.',
    'portal.shipping.title': 'Política de Envios',
    'portal.shipping.disclaimer.title': 'ISENÇÃO DE RESPONSABILIDADE:',
    'portal.shipping.disclaimer.body': 'A RAREGROOVE atua exclusivamente como plataforma de intermediação. O site NÃO participa da logística, coleta ou entrega dos itens. A responsabilidade pelo envio é 100% dos usuários envolvidos na transação.',
    'portal.shipping.rules.title': 'Regras de Envio',
    'portal.shipping.rules.items': 'Rastreamento é obrigatório em todos os envios;Enviar em até 2 dias após confirmação da venda;Embalar com plástico bolha e proteção rígida nos cantos;Marcar a caixa com "FRÁGIL" e seta de verticalidade;Tirar foto do CD antes de empacotar (prova de condição);Informar o código de rastreio na plataforma após envio',
    'portal.shipping.modalities.title': 'Modalidades de Envio (Referência)',
    'portal.shipping.modalities.headers.mode': 'Modalidade',
    'portal.shipping.modalities.headers.use': 'Sugestão de Uso',
    'portal.shipping.modalities.headers.note': 'Observação',
    'portal.shipping.modalities.rows.pac': 'PAC / Econômico|CDs de menor valor|Válido para mídias impressas',
    'portal.shipping.modalities.rows.sedex': 'SEDEX / Expresso|Itens de alto valor|Melhor manuseio, mais seguro',
    'portal.shipping.modalities.rows.carrier': 'Transportadora|Coleções, volumes maiores|Melhor para capas sensíveis',
    'portal.shipping.damage.title': 'Em caso de danos no transporte',
    'portal.shipping.damage.body': 'O comprador deve documentar (fotos/vídeos) e acionar o seguro da transportadora contratada. A RAREGROOVE poderá suspender contas que apresentem recorrência em envios mal embalados. Disputas por dano em transporte devem ser abertas em até 7 dias do recebimento.',
    'portal.dmca.title': 'DMCA & Direitos Autorais',
    'portal.dmca.lastUpdate': 'Última atualização: 12 de Fevereiro de 2026',
    'portal.dmca.intro': 'RAREGROOVE cumpre com a Lei de Direitos Autorais Digital (DMCA) de 1998 e legislação similar de proteção de direitos autorais em outras jurisdições.',
    'portal.dmca.user.title': 'Responsabilidade do Usuário',
    'portal.dmca.user.lead': 'RAREGROOVE não é responsável pelo conteúdo enviado pelos usuários. Os usuários são 100% responsáveis pelo conteúdo de suas contas. Cada usuário declara que:',
    'portal.dmca.user.items': 'Possui direitos legais sobre o conteúdo que armazena;Possui cópias físicas originais de qualquer material no Serviço;Não infringirá direitos autorais de terceiros;Não utilizará o Serviço para distribuição ou compartilhamento comercial não autorizado',
    'portal.dmca.notice.title': 'Como Enviar uma Notificação DMCA',
    'portal.dmca.notice.lead': 'Sua notificação DMCA deve conter:',
    'portal.dmca.notice.items': 'Assinatura física ou eletrônica do detentor de direitos;Descrição da obra protegida infringida;URL específica ou identificação exata do conteúdo infrator;Seu nome, endereço, telefone e email;Declaração sob pena de perjúrio que você é o detentor autorizado;Que as informações são precisas e você está autorizado a agir',
    'portal.dmca.notice.warning': 'Aviso: Notificações falsas ou maliciosas podem resultar em responsabilidade legal conforme 17 U.S.C. § 512(f).',
    'portal.dmca.response.title': 'Tempos de Resposta',
    'portal.dmca.response.headers.type': 'Tipo de Solicitação',
    'portal.dmca.response.headers.time': 'Tempo de Resposta',
    'portal.dmca.response.rows.receipt': 'Notificação DMCA (recebimento)|24 horas',
    'portal.dmca.response.rows.removal': 'Remoção de conteúdo|72 horas (máximo)',
    'portal.dmca.response.rows.counter': 'Contra-notificação (recebimento)|30 dias úteis',
    'portal.dmca.response.rows.legal': 'Resposta a consultoria legal|Conforme exigido por lei',
    'portal.dmca.policy.title': 'Política de Reincidência',
    'portal.dmca.policy.items': '1ª infração: Aviso por email + remoção de conteúdo;2ª infração: Suspensão temporária de 30 dias;3ª infração: Banimento permanente + possível ação legal'
    ,
    'portal.about.quote': 'RAREGROOVE é o maior marketplace de CDs raros da América Latina. Conectamos colecionadores, apaixonados por música e traders de forma segura, verificada e justa. Onde encontrar raridades é fácil, e vender sua coleção é seguro.',
    'portal.about.lead': 'RAREGROOVE é um marketplace peer-to-peer seguro para compra, venda e troca de CDs raros. Funcionamos como intermediários confiáveis, oferecendo sistema de custódia (escrow) que protege ambos compradores e vendedores em cada transação.',
    'portal.about.how.title': 'Como Funciona',
    'portal.about.how.items': 'Cadastre-se|Gratuito, leva 2 minutos;Procure ou liste|Busque por artista/álbum ou liste sua coleção;Negocie com segurança|Chat privado com proteção de privacidade;Pagamento seguro|Seu dinheiro fica conosco até confirmar recebimento;Rastreamento obrigatório|Todo CD envia com rastreio e cobertura;Mediação especializada|Se houver problema, nossos especialistas resolvem',
    'portal.about.compare.title': 'RAREGROOVE vs Concorrência',
    'portal.about.compliance.title': 'Conformidade Legal',
    'portal.about.compliance.items': 'Lei de Defesa do Consumidor (Brasil) — 8.078/1990;LGPD — Lei Geral de Proteção de Dados (13.709/2018);DMCA — Digital Millennium Copyright Act (1998);Regulamentações de serviço de custódia e intermediação financeira',
    'portal.faq.title': 'Perguntas Frequentes',
    'portal.faq.q1.title': 'Meu dinheiro está seguro na plataforma?',
    'portal.faq.q1.body': 'Sim. O sistema de custódia (escrow) mantém seu pagamento conosco até você confirmar o recebimento do CD em bom estado. O vendedor só recebe após sua confirmação.',
    'portal.faq.q2.title': 'O que acontece se o CD não chegar ou for diferente do anunciado?',
    'portal.faq.q2.body': 'Você tem 7 dias após o recebimento para abrir uma disputa. Se o CD não chegar em 30 dias, você recebe 100% de volta. Se for falsificado, recebe 100% de volta sem precisar devolver.',
    'portal.faq.q3.title': 'Como a RAREGROOVE protege meus dados pessoais?',
    'portal.faq.q3.body': 'Seguimos rigorosamente a LGPD. Seus dados são criptografados, nunca vendidos a terceiros e você pode solicitar exclusão a qualquer momento. Veja nossa Política de Privacidade para detalhes completos.',
    'portal.faq.q4.title': 'Posso sair da plataforma para negociar diretamente?',
    'portal.faq.q4.body': 'Não. Negociar fora da plataforma viola nossa Política da Comunidade e remove todas as proteções de comprador e vendedor. Nosso chat integrado é seguro e mantém histórico para mediação.',
    'portal.faq.q5.title': 'Como denunciar um vendedor desonesto?',
    'portal.faq.q5.body': 'Abra uma disputa na plataforma ou envie um email para raregroovecdseswapsafe@gmail.com com evidências (fotos, screenshots). Nossa equipe analisa em até 16 dias.',
    'catalog.title': 'O Catálogo',
    'catalog.header': 'Catálogo de',
    'catalog.header.gold': 'Relíquias',
    'catalog.itemsAvailable': 'CDs disponíveis para negociação',
    'catalog.filters.searchLabel': 'Buscar por Título/Artista',
    'catalog.filters.searchPlaceholder': 'Procure um CD...',
    'catalog.filters.genre': 'Gênero',
    'catalog.filters.allGenres': 'Todos os Gêneros',
    'catalog.filters.year': 'Ano',
    'catalog.filters.allYears': 'Todos os Anos',
    'catalog.filters.yearPlaceholder': 'Ex: 1970',
    'catalog.filters.minPrice': 'Preço Mínimo',
    'catalog.filters.minPlaceholder': 'R$ 0',
    'catalog.filters.maxPrice': 'Preço Máximo',
    'catalog.filters.maxPlaceholder': 'R$ 99999',
    'catalog.actions.clearFilters': 'Limpar Filtros',
    'catalog.actions.addToWishlist': 'Adicionar à Wishlist',
    'catalog.actions.add': 'Anunciar Relíquia',
    'catalog.actions.addedToWishlist': 'Adicionado à lista de desejos',
    'catalog.actions.removedFromWishlist': 'Removido da lista de desejos',
    'catalog.empty.title': 'Nenhum CD encontrado',
    'catalog.empty.suggestion': 'Tente ajustar os filtros de busca',
    'catalog.empty.noneFound': 'Não encontramos',
    'catalog.empty.inCollection': 'em nosso acervo',
    'catalog.empty.noResults': 'Sem Resultados',
    'catalog.empty.showcaseEmpty': 'Vitrine Vazia',
    'catalog.empty.searchNoResults': 'Nenhuma pérola encontrada para',
    'catalog.empty.noItems': 'Esta coleção ainda não tem tesouros. Seja o primeiro a adicionar!',
    'catalog.empty.loginPrompt': 'Faça login para começar sua coleção',
    'grooveflix.reload': 'Recarregar',
    'grooveflix.upload': 'Upload',
    'grooveflix.filter.all': 'Todos',
    'grooveflix.empty.title': 'Nenhum conteúdo encontrado',
    'grooveflix.empty.login': 'Faça login para ver seu conteúdo.',
    'grooveflix.empty.upload': 'Faça upload de conteúdo Grooveflix para começar.',
    'grooveflix.empty.filter': 'Tente mudar o filtro de categoria.',
    'grooveflix.play': 'Reproduzir',
    'grooveflix.noAudio': 'Sem áudio',
    'grooveflix.loadingAlbum': 'Carregando álbum...',
    'grooveflix.playing': 'Reproduzindo...',
    'grooveflix.error.noAudio': 'Esta faixa não possui arquivo de áudio.',
    'grooveflix.error.load': 'Erro ao carregar',
    'grooveflix.tracks': 'faixas',
    'grooveflix.delete.confirm': 'Excluir este item?',
    'grooveflix.delete.irreversible': 'Esta ação não pode ser desfeita',
    'grooveflix.delete.action': 'Excluir',
    'grooveflix.delete.cancel': 'Cancelar',
    'grooveflix.delete.error': 'Erro ao deletar',
    'grooveflix.delete.success': 'Item deletado!',
    'grooveflix.upload.minFiles': 'Selecione uma pasta com pelo menos 2 músicas',
    'grooveflix.upload.fileTooBig': 'Arquivo muito grande',
    'grooveflix.upload.maxSize': 'Máximo',
    'grooveflix.upload.coverError': 'Erro no upload da capa',
    'grooveflix.upload.audioError': 'Erro no upload do áudio',
    'grooveflix.upload.generalError': 'Erro ao fazer upload',
    'grooveflix.upload.titleRequired': 'Preencha o título e artista',
    'grooveflix.upload.submit': 'Adicionar ao Grooveflix',
    'grooveflix.upload.success': 'CD adicionado ao Grooveflix!',
    'grooveflix.upload.updated': 'CD atualizado com sucesso!',
    'grooveflix.upload.category.single': 'Single',
    'grooveflix.upload.category.singleDesc': 'Uma faixa individual',
    'grooveflix.upload.category.album': 'Álbum',
    'grooveflix.upload.category.albumDesc': 'Pasta com todas as músicas',
    'grooveflix.upload.category.compilation': 'Coletânea',
    'grooveflix.upload.category.compilationDesc': 'Compilação de faixas',
    'grooveflix.upload.category.isoDesc': 'CD completo (imagem ISO)',
    'grooveflix.upload.fileType.audio': 'Áudio (MP3/FLAC/WAV)',
    'grooveflix.upload.fileType.folder': 'Pasta com músicas',
    'grooveflix.upload.fileType.preview': 'Preview (opcional)',
    'grooveflix.upload.fileType.iso': 'ISO (CD Completo)',
    'grooveflix.upload.fileType.booklet': 'Encarte/PDF (opcional)',
    'grooveflix.upload.fileType.cover': 'Capa (imagem)',
    'grooveflix.discogs.searchPlaceholder': 'Ex: Miles Davis Kind of Blue...',
    'grooveflix.discogs.searching': 'Buscando...',
    'grooveflix.discogs.search': 'Buscar',
    'grooveflix.discogs.noResults': 'Nenhum resultado encontrado',
    'grooveflix.discogs.resultsFound': 'resultados encontrados',
    'grooveflix.discogs.fetchingDetails': 'Carregando detalhes...',
    'grooveflix.discogs.fetchError': 'Erro ao buscar detalhes',
    'grooveflix.discogs.importSuccess': 'Dados importados do Discogs!',
    'grooveflix.discogs.tracklist': 'Tracklist',
    'grooveflix.discogs.tracks': 'faixas',
    'grooveflix.discogs.moreTracks': '... e mais',
    'grooveflix.discogs.format': 'Formato',
    'grooveflix.discogs.viewOnDiscogs': 'Ver no Discogs',
    'grooveflix.discogs.import': 'Importar Dados',
    'grooveflix.discogs.noResultsQuery': 'Nenhum resultado para',
    'grooveflix.discogs.searchTip': 'Digite um termo de busca para encontrar álbuns',
    'profile.logout': 'Sair',
    'profile.tabs.overview': 'Visão Geral',
    'profile.tabs.addresses': 'Meus Endereços',
    'profile.tabs.financial': 'Financeiro',
    'profile.tabs.swaps': 'Trocas',
    'profile.tabs.purchases': 'Compras',
    'profile.tabs.wishlist': 'Lista de Desejos',
    'profile.tabs.settings': 'Configurações',
    'profile.reputation.title': 'Reputação na Comunidade',
    'profile.latestReviews': 'Últimas Avaliações',
    'profile.noComments': 'Nenhum comentário ainda',
    'profile.myListedCds': 'Meus CDs Listados',
    'profile.viewAll': 'Ver Todos',
    'profile.noListed': 'Você ainda não listou nenhum CD.',
    'profile.personalData.title': 'Dados Pessoais',
    'profile.personalData.fullName': 'Nome Completo',
    'profile.personalData.cpf': 'CPF',
    'profile.personalData.phone': 'Telefone',
    'profile.personalData.pix': 'Chave PIX',
    'profile.financial.title': 'Dashboard Financeiro',
    'profile.swaps.title': 'Histórico de Trocas',
    'profile.swaps.empty': 'Você ainda não realizou nenhuma troca.',
    'profile.purchases.title': 'Histórico de Compras',
    'profile.purchases.empty': 'Você ainda não realizou nenhuma compra.',
    'profile.exploreCatalog': 'Explorar Catálogo',
    'profile.wishlist.title': 'Meus Desejos',
    'profile.wishlist.add': 'Adicionar Desejo',
    'profile.settings.title': 'Configurações de Perfil',
    'profile.settings.edit': 'Editar Dados',
    'profile.form.notice': '⚠️ Esses dados serão utilizados na geração das etiquetas de envio dos CDs.',
    'profile.form.fullNamePlaceholder': 'Seu nome completo',
    'profile.form.address': 'Endereço (Rua/Avenida) *',
    'profile.form.addressPlaceholder': 'Rua, Avenida, etc',
    'profile.form.number': 'Número *',
    'profile.form.numberPlaceholder': 'Número ou SN',
    'profile.form.complement': 'Complemento',
    'profile.form.complementPlaceholder': 'Apt, Bloco, etc',
    'profile.form.city': 'Cidade *',
    'profile.form.cityPlaceholder': 'Sua cidade',
    'profile.form.state': 'Estado (UF) *',
    'profile.form.pixKey': 'Chave PIX (CPF, telefone, email ou chave aleatória) *',
    'profile.form.pixKeyPlaceholder': 'Sua chave PIX para receber',
    'profile.form.fetchingAddress': 'Buscando endereço...',
    'profile.form.dataInfoTitle': '📋 Informações sobre seus dados:',
    'profile.form.dataInfo.nameCpf': 'Nome completo e CPF: Utilizados em etiquetas de envio',
    'profile.form.dataInfo.phone': 'Telefone: Para contato em caso de dúvidas sobre envios',
    'profile.form.dataInfo.address': 'Endereço: Local de retirada se optar por entrega local',
    'profile.form.dataInfo.pixKey': 'Chave PIX: Para receber pagamentos de vendas',
    'profile.form.save': 'Salvar Dados',
    'profile.form.cancel': 'Cancelar',
    'profile.addresses.title': 'Meus Endereços de Entrega',
    'profile.addresses.add': 'Adicionar Endereço',
    'profile.addresses.none': 'Nenhum endereço cadastrado',
    'profile.addresses.first': 'Cadastre seu primeiro endereço',
    'profile.addresses.defaultBadge': 'PADRÃO',
    'profile.addresses.btn.edit': 'Editar',
    'profile.addresses.btn.default': 'Tornar Padrão',
    'profile.addresses.btn.delete': 'Deletar',
    'profile.addresses.modal.edit': 'Editar Endereço',
    'profile.addresses.modal.new': 'Novo Endereço',
    'profile.addresses.modal.label': 'Identifique o Endereço (ex: Casa, Trabalho) *',
    'profile.addresses.modal.labelPlaceholder': 'Ex: Casa do Colecionador',
    'profile.addresses.modal.name': 'Nome Completo *',
    'profile.addresses.modal.namePlaceholder': 'Nome do destinatário',
    'profile.addresses.modal.phone': 'Telefone',
    'profile.addresses.modal.cep': 'CEP *',
    'profile.addresses.modal.address': 'Endereço (Rua/Avenida) *',
    'profile.addresses.modal.addressPlaceholder': 'Rua, Avenida, etc',
    'profile.addresses.modal.number': 'Número *',
    'profile.addresses.modal.numberPlaceholder': 'Número ou SN',
    'profile.addresses.modal.complement': 'Complemento',
    'profile.addresses.modal.complementPlaceholder': 'Apt, Bloco, etc',
    'profile.addresses.modal.city': 'Cidade *',
    'profile.addresses.modal.cityPlaceholder': 'Sua cidade',
    'profile.addresses.modal.state': 'Estado (UF) *',
    'profile.addresses.modal.saving': 'Salvando...',
    'profile.addresses.modal.save': 'Salvar Endereço',
    'profile.addresses.modal.cancel': 'Cancelar'
    ,
    'item.notFound': 'ITEM NÃO ENCONTRADO',
    'item.notFoundDesc': 'Esta relíquia não foi localizada',
    'item.priceLabel': 'VALOR DE MERCADO',
    'item.sellerLabel': 'ACERVO DE',
    'item.buyAction': 'COMPRAR AGORA',
    'item.swapAction': 'PROPOR TROCA',
    'item.protectedTransaction': 'Transação Protegida pelo Protocolo Rare Groove',
    'item.chatTitle': 'NEGOCIAÇÃO DIRETA',
    'item.chatPlaceholder': 'Olá, tenho interesse nessa relíquia...',
    'item.ownItemError': 'Você não pode negociar seu próprio item',
    'auth.required': 'Faça login para continuar',
    'messages.badge': 'Comunicação',
    'messages.title': 'Mensagens',
    'messages.subtitle': 'Negocie dentro do Rare Groove',
    'messages.backToCatalog': 'VOLTAR AO CATÁLOGO',
    'messages.empty': 'Nenhuma conversa encontrada.'
    ,
    'messagesWithUnread.badge': 'Comunicação',
    'messagesWithUnread.title': 'Mensagens',
    'messagesWithUnread.allRead': 'TODAS AS MENSAGENS LIDAS',
    'messagesWithUnread.unreadCount': 'MENSAGENS NÃO LIDAS',
    'messagesWithUnread.tabs.conversations': 'Conversas',
    'messagesWithUnread.tabs.archived': 'Arquivadas',
    'messagesWithUnread.empty': 'Vazio por aqui.',
    'messagesWithUnread.newBadge': 'NOVA',
    'messagesWithUnread.backToCatalog': 'VOLTAR AO CATÁLOGO',
    'messagesWithUnread.backToCatalogo': 'VOLTAR AO CATÁLOGO',
    'messagesWithUnread.empty.title': 'NENHUMA MENSAGEM ENCONTRADA',
    'messagesWithUnread.empty.desc': 'Você ainda não iniciou nenhuma conversa.',
    'messagesWithUnread.empty.archived': 'NENHUMA CONVERSA ARQUIVADA',
    'messagesWithUnread.empty.archivedDesc': 'Conversas antigas que você arquivou aparecerão nesta seção.',
    'swaps.loading': 'Carregando swaps...',
    'swaps.badge': 'Sistema de Permutas',
    'swaps.title.prefix': 'Trocas',
    'swaps.title.highlight': 'Garantidas',
    'swaps.subtitle': 'Gerencie permutas com garantia dupla e confirmações individuais',
    'swaps.backToPortal': 'VOLTAR AO PORTAL',
    'swaps.tabs.list': 'Lista de Swaps',
    'swaps.tabs.simulator': 'Simulador',
    'swaps.tabs.create': 'Criar Swap',
    'swaps.empty.title': 'Nenhum swap encontrado',
    'swaps.empty.desc': 'Ainda não há permutas registradas no sistema.',
    'swaps.createdAt': 'Criado em',
    'swaps.completedAt': 'Troca concluída em',
    'swaps.confirm.cancel': 'Tem certeza que deseja cancelar esta troca?',
    'swaps.alerts.guaranteePaid': 'Taxa de garantia paga com sucesso!',
    'swaps.alerts.receiptConfirmed': 'Recebimento confirmado!',
    'swaps.alerts.swapCancelled': 'Troca cancelada com sucesso',
    'swaps.errors.payment': 'Erro ao processar pagamento',
    'swaps.errors.confirm': 'Erro ao confirmar',
    'swaps.errors.cancel': 'Erro ao cancelar',
    'swaps.actions.cancel': 'Cancelar Troca',
    'swaps.actions.payGuarantee': 'Pagar Taxa de Garantia',
    'swaps.actions.confirmReceipt': 'Confirmar Recebimento',
    'swaps.status.waitingOtherParty': 'Aguardando confirmação da outra parte',
    'swaps.labels.feePaid': 'Taxa paga',
    'swaps.labels.feePending': 'Taxa pendente',
    'swaps.labels.confirmed': 'Confirmado',
    'swaps.labels.condition': 'Condição',
    'swaps.fee.perPerson': 'Taxa por pessoa',
    'swaps.fee.totalInCustody': 'Total em custódia',
    'swaps.fee.totalRefund': 'Reembolso total estimado',
    'swaps.fee.individualRefundLabel': 'Reembolso individual:',
    'swaps.status.proposta_criada': 'Proposta Criada',
    'swaps.status.aguardando_checkin': 'Aguardando Check-in',
    'swaps.status.checkin_parcial': 'Check-in Parcial',
    'swaps.status.etiquetas_liberadas': 'Etiquetas Liberadas',
    'swaps.status.em_transito': 'Em Trânsito',
    'swaps.status.aguardando_confirmacao_recebimento': 'Aguardando Confirmação',
    'swaps.status.concluida': 'Concluída',
    'swaps.status.sinistro_aberto': 'Sinistro Aberto',
    'swaps.status.sinistro_em_analise': 'Sinistro em Análise',
    'swaps.status.sinistro_resolvido_venda_reversa': 'Sinistro Resolvido',
    'swaps.status.cancelada': 'Cancelada',
    'swaps.status.aguardando_taxas': 'Aguardando Taxas',
    'swaps.status.autorizado_envio': 'Autorizado Envio',
    'swaps.status.em_troca': 'Em Troca',
    'swaps.status.concluido': 'Concluído',
    'swaps.status.cancelado': 'Cancelado',
    'swaps.simulator.title': 'Simulador de Swap',
    'swaps.simulator.guaranteeFeePerPerson': 'Taxa de Garantia (por pessoa)',
    'swaps.simulator.portalKeepPct': '% Retido pelo Portal',
    'swaps.simulator.paymentStatus': 'Status de Pagamento',
    'swaps.simulator.user1Paid': 'Usuário 1 pagou taxa',
    'swaps.simulator.user2Paid': 'Usuário 2 pagou taxa',
    'swaps.simulator.confirmationStatus': 'Status de Confirmação',
    'swaps.simulator.user1Confirmed': 'Usuário 1 confirmou recebimento',
    'swaps.simulator.user2Confirmed': 'Usuário 2 confirmou recebimento',
    'swaps.simulator.financialCalc': 'Cálculos Financeiros',
    'swaps.simulator.feePerPerson': 'Taxa por pessoa',
    'swaps.simulator.totalInCustody': 'Total em custódia',
    'swaps.simulator.portalKeeps': 'Portal retém',
    'swaps.simulator.totalRefund': 'Reembolso total',
    'swaps.simulator.refundPerPerson': 'Reembolso por pessoa',
    'swaps.simulator.swapStatus': 'Status do Swap',
    'swaps.simulator.bothPaid': 'Ambas taxas pagas',
    'swaps.simulator.readyToShip': 'Autorizado para envio',
    'swaps.simulator.bothConfirmed': 'Ambos confirmaram recebimento',
    'swaps.simulator.completed': 'Swap concluído',
    'swaps.simulator.successTitle': 'Swap Concluído com Sucesso!',
    'swaps.simulator.successDescPrefix': 'Cada usuário receberá',
    'swaps.simulator.successDescSuffix': 'de reembolso',
    'swaps.adminCreate.title': 'Criar Novo Swap (Admin)',
    'swaps.adminCreate.desc': 'Funcionalidade em desenvolvimento. Use a interface de chat para iniciar trocas entre usuários.',
    'swaps.adminCreate.howItWorks': 'Como funciona',
    'swaps.adminCreate.steps.1': 'Usuários negociam troca via chat',
    'swaps.adminCreate.steps.2': 'Sistema cria registro no banco com ambos itens',
    'swaps.adminCreate.steps.3': 'Cada usuário paga taxa de garantia',
    'swaps.adminCreate.steps.4': 'Após ambos pagarem, podem enviar itens',
    'swaps.adminCreate.steps.5': 'Cada um confirma recebimento individualmente',
    'swaps.adminCreate.steps.6': 'Sistema reembolsa após confirmações',
    'chat.closeDeal': 'Fechar Negócio',
    'chat.processing': 'Processando...',
    'chat.activeTransaction': 'EM NEGOCIAÇÃO',
    'catalog.card.value': 'Valor',
    'chat.archive': 'Arquivar',
    'chat.archiving': 'Arquivando...',
    'chat.header.talkingTo': 'Conversando com',
    'chat.emptyPrompt': 'Comece a conversa...',
    'chat.input.placeholder': 'Digite sua mensagem...',
    'chat.modal.title': 'CONFIRMAR NEGOCIAÇÃO',
    'chat.modal.lead': 'Fechar este acordo',
    'chat.modal.buyerConfirmed': 'Comprador confirmado',
    'paymentSuccess.sold': 'VENDIDO',
    'checkout.badge': 'TRANSAÇÃO SEGURA',
    'checkout.title': 'Finalizar',
    'checkout.title.gold': 'Aquisição',
    'checkout.subtitle': 'AUTENTICIDADE E SEGURANÇA GARANTIDAS',
    'checkout.itemSummary': 'Resumo da Relíquia',
    'checkout.paymentMethod': 'Método de Pagamento',
    'checkout.orderSummary': 'Resumo Financeiro',
    'checkout.actions.continue': 'Confirmar e Pagar',
    'checkout.actions.back': 'Voltar para seleção',
    'checkout.securePayment': 'Pagamento 100% Criptografado',
    'checkout.labels.condition': 'Condição',
    'checkout.labels.seller': 'Vendedor',
    'checkout.labels.itemValue': 'Valor da Relíquia',
    'checkout.labels.fee': 'Taxa de Curadoria',
    'checkout.labels.processing': 'Processamento Seguro',
    'checkout.labels.total': 'Total do Investimento',
    'checkout.protection.title': 'RareGroove Protection',
    'checkout.protection.desc': 'Seu investimento está seguro',
    'checkout.payment.creditCard': 'Cartão de Crédito',
    'checkout.payment.creditCardDesc': 'Stripe Secure',
    'checkout.payment.mercadoPago': 'Mercado Pago',
    'checkout.payment.mercadoPagoDesc': 'Pix, Boleto e Cartão',
    'checkout.payment.paypal': 'PayPal',
    'checkout.payment.paypalDesc': 'PayPal Wallet',
    'checkout.success.title': 'Comprovante Enviado',
    'checkout.success.desc': 'Redirecionando para o cofre...',
    'checkout.error.config': 'Erro na Configuração',
    'checkout.error.noGateway': 'Nenhum método de pagamento disponível no momento. Contate o suporte da RareGroove.'
  },
  'en-US': {
    'auth.login.badge': 'RESTRICTED ACCESS',
    'auth.signup.badge': 'NEW MEMBER',
    'auth.subtitle': 'THE COLLECTORS VAULT',
    'auth.form.fullName': 'Full Name',
    'auth.form.fullName.placeholder': 'Your full name',
    'auth.form.country': 'Country',
    'auth.form.cpf': 'CPF/CNPJ (Brazil)',
    'auth.form.cpf.placeholder': '000.000.000-00',
    'auth.form.rg': 'RG (Brazil)',
    'auth.form.rg.placeholder': '00.000.000-0',
    'auth.form.taxId': 'Tax ID / National ID',
    'auth.form.taxId.placeholder': 'A1B2C3',
    'auth.form.taxId.hint': '📝 National identifier (Tax ID)',
    'auth.form.taxId.invalid': 'Invalid document',
    'auth.form.taxId.invalidDesc': 'Enter a valid Tax ID / National ID.',
    'auth.form.passport': 'Passport / ID Number',
    'auth.form.passport.placeholder': 'X1234567',
    'auth.form.passport.hint': '📝 Document (Passport/ID)',
    'auth.form.passport.invalid': 'Invalid document',
    'auth.form.passport.invalidDesc': 'Enter a valid Passport / ID Number.',
    'auth.form.email': 'Access Email',
    'auth.form.password': 'Encrypted Password',
    'auth.form.remember': 'REMEMBER ME',
    'auth.form.forgot': 'FORGOT PASSWORD',
    'auth.login.submit': 'ENTER VAULT',
    'auth.signup.submit': 'CREATE CREDENTIALS',
    'auth.login.processing': 'ENTERING...',
    'auth.signup.processing': 'CREATING...',
    'auth.login.toggle': 'NO ACCOUNT? SIGN UP',
    'auth.signup.toggle': 'ALREADY HAVE AN ACCOUNT? LOGIN',
    'country.br': 'Brazil',
    'country.us': 'United States',
    'country.ca': 'Canada',
    'country.gb': 'United Kingdom',
    'country.pt': 'Portugal',
    'country.es': 'Spain',
    'country.fr': 'France',
    'country.de': 'Germany',
    'country.ar': 'Argentina',
    'country.mx': 'Mexico',
    'country.other': 'Other',
    'notFound.title': 'Oops! This record got scratched',
    'notFound.description': 'The page you are looking for was not found in the catalog',
    'notFound.tip': 'Looks like this page is rarer than a 1963 Beatles original.',
    'notFound.ctaBack': 'Go Back',
    'notFound.ctaExplore': 'Explore Catalog',
    'notFound.ctaPortal': 'Portal',
    'nav.explore': 'Explore',
    'nav.grooveflix': 'Grooveflix',
    'nav.plans': 'Plans',
    'nav.myItems': 'My Collection',
    'nav.swaps': 'Swaps',
    'nav.community': 'Community',
    'nav.search.placeholder': 'Search CDs...',
    'nav.search.submit': 'Search',
    'nav.dropdown.profile': 'My Profile',
    'nav.dropdown.balance': 'My Balance',
    'nav.dropdown.settings': 'Settings',
    'nav.dropdown.logout': 'Sign Out',
    'nav.dropdown.language': 'Language',
    'nav.admin.bank': 'RareGroove Bank',
    'nav.admin.profiles': 'Profile Manager',
    'myItems.title.prefix': 'My',
    'myItems.title.highlight': 'Collection',
    'myItems.subtitle': 'Sales and swaps management',
    'myItems.actions.add': 'List CD',
    'myItems.empty': 'No items listed.',
    'myItems.status.negotiation': 'IN NEGOTIATION',
    'myItems.status.sold': 'SOLD',
    'myItems.badge.sale': 'Sale',
    'myItems.badge.swap': 'Swap',
    'myItems.toast.loadError.title': 'LOAD ERROR',
    'myItems.toast.loadError.desc': 'Could not load your collection',
    'myItems.toast.invalidConfirm.title': 'INVALID CONFIRMATION',
    'myItems.toast.invalidConfirm.desc': 'Type DELETE to confirm',
    'myItems.toast.deleteBlocked.title': 'DELETE BLOCKED',
    'myItems.toast.deleteBlocked.desc': 'Sold items can only be deleted by an administrator.',
    'myItems.toast.deleted.title': 'ITEM REMOVED',
    'myItems.toast.deleted.desc': 'The item was removed from your collection',
    'myItems.toast.deleteError.title': 'DELETE ERROR',
    'myItems.toast.deleteError.desc': 'Could not remove the item. Check your permissions.',
    'myItems.errors.notAuthenticated': 'User not authenticated',
    'myItems.errors.fkBlocked': 'This item cannot be deleted because it has sales or swap history.',
    'myItems.delete.confirmWord': 'DELETE',
    'myItems.deleteModal.title': 'CONFIRM DELETE',
    'myItems.deleteModal.subtitle': 'This action cannot be undone',
    'myItems.deleteModal.itemLabel': 'Item to delete',
    'myItems.deleteModal.typePrefix': 'Type',
    'myItems.deleteModal.typeSuffix': 'to confirm',
    'myItems.actions.cancel': 'Cancel',
    'myItems.actions.delete': 'Delete Item',
    'addItem.title.new': 'LIST NEW ITEM',
    'addItem.title.edit': 'EDIT RELIC',
    'addItem.fields.title': 'Album Title',
    'addItem.fields.artist': 'Artist / Band',
    'addItem.fields.price': 'Price',
    'addItem.fields.condition': 'Condition',
    'addItem.fields.coverUrl': 'Album Cover URL',
    'addItem.placeholders.coverUrl': 'https://...',
    'addItem.fields.allowSale': 'Available for Sale',
    'addItem.fields.allowSwap': 'Available for Swap',
    'addItem.fields.realPhoto': 'Real Photo of the Relic',
    'addItem.upload.selectFile': 'Click to select a file',
    'addItem.actions.publish': 'AUTHENTICATE & PUBLISH',
    'addItem.actions.save': 'SAVE CHANGES',
    'addItem.condition.MINT': 'MINT (New)',
    'addItem.condition.NM': 'Near Mint',
    'addItem.condition.VG_PLUS': 'Very Good+',
    'addItem.condition.VG': 'Very Good',
    'addItem.toast.created.title': 'RELIC LISTED!',
    'addItem.toast.updated.title': 'CHANGES SAVED!',
    'addItem.toast.error.title': 'ERROR',
    'addItem.toast.error.desc': 'Could not save the item.',
    'addItem.errors.notAuthenticated': 'User not authenticated',
    'wishlist.modal.title.add': 'Add to Wishlist',
    'wishlist.modal.title.edit': 'Edit Wish',
    'wishlist.modal.fields.itemName': 'Item Name',
    'wishlist.modal.fields.artist': 'Artist (optional)',
    'wishlist.modal.fields.maxPrice': 'Max Price (optional)',
    'wishlist.modal.fields.category': 'Category (optional)',
    'wishlist.modal.fields.description': 'Notes (optional)',
    'wishlist.modal.placeholders.itemName': 'e.g. Dark Side of the Moon, Michael Jackson...',
    'wishlist.modal.placeholders.artist': 'e.g. Pink Floyd, Queen...',
    'wishlist.modal.placeholders.maxPrice': 'e.g. 150.00',
    'wishlist.modal.placeholders.description': 'e.g. First pressing, Japanese edition...',
    'wishlist.modal.hints.itemName': 'Use keywords to improve matching',
    'wishlist.modal.hints.maxPrice': 'Leave empty to receive all matches',
    'wishlist.modal.errors.missingItemName': 'Please enter the name of the desired item',
    'wishlist.category.all': 'All categories',
    'wishlist.category.Novo': 'New',
    'wishlist.category.Seminovo': 'Like New',
    'wishlist.category.Usado': 'Used',
    'wishlist.category.Colecionador': 'Collector',
    'wishlist.actions.cancel': 'Cancel',
    'wishlist.actions.saving': 'Saving...',
    'wishlist.actions.update': 'Update',
    'wishlist.actions.add': 'Add',
    'wishlist.actions.pause': 'Pause',
    'wishlist.actions.activate': 'Activate',
    'wishlist.actions.edit': 'Edit',
    'wishlist.actions.remove': 'Remove',
    'wishlist.errors.notAuthenticated': 'User not authenticated',
    'wishlist.toast.created.title': '✨ Wish added!',
    'wishlist.toast.created.desc': 'You will be notified when we find a match',
    'wishlist.toast.updated.title': '✨ Wish updated!',
    'wishlist.toast.error.title': 'Error saving wish',
    'wishlist.toast.error.desc': 'Could not save the wish.',
    'wishlist.toast.removed.title': 'Wish removed',
    'wishlist.toast.removeError.title': 'Error removing wish',
    'wishlist.toast.paused.title': 'Wish paused',
    'wishlist.toast.activated.title': 'Wish activated',
    'wishlist.toast.toggleError.title': 'Error updating wish',
    'wishlist.card.confirmRemove': 'Remove this wish from the list?',
    'wishlist.card.artistLabel': 'Artist:',
    'wishlist.card.maxPriceLabel': 'Up to:',
    'wishlist.card.categoryLabel': 'Category:',
    'wishlist.card.addedAt': 'Added on',
    'wishlist.card.status.searching': 'Searching',
    'wishlist.card.status.paused': 'Paused',
    'wishlist.empty.title': 'Your Wishlist is empty',
    'wishlist.empty.desc': 'Add rare items you are looking for and get notified automatically when they appear in the collection!',
    'wishlist.empty.addFirst': 'Add First Wish',
    'portal.hero.badge': 'Transparency & Legal Compliance Portal',
    'portal.hero.subtitle1': 'The largest rare CDs marketplace in Latin America',
    'portal.hero.subtitle2': 'Transparency, security and full legal compliance',
    'portal.sidebar.title': 'Documents',
    'portal.section.sobre': 'About the Platform',
    'portal.section.imortalidade': 'The Journey of Immortality',
    'portal.section.termos': 'Terms of Service',
    'portal.section.privacidade': 'Privacy & LGPD',
    'portal.section.comunidade': 'Community Policy',
    'portal.section.envios': 'Shipping Policy',
    'portal.section.dmca': 'DMCA & Copyright'
    ,
    'portal.immortality.intro': 'Grooveflix is born from the ritual of preserving what is rare. Here, you turn physical media into eternal memory: bit‑perfect extraction, rip validation and storage in the Digital Sarcophagus for Hi‑Fi streaming.',
    'portal.immortality.step1.title': 'Step 1: The Perfect Extraction',
    'portal.immortality.step1.body': 'Use Exact Audio Copy (EAC) in secure mode to produce bit‑perfect copies. The EAC log is the proof of the ritual.',
    'portal.immortality.step1.cta': 'Download Exact Audio Copy (Official)',
    'portal.immortality.step2.title': 'Step 2: The Upload Ritual',
    'portal.immortality.step2.body': 'Upload the .flac and the EAC .log for Gemini validation. It checks integrity, offsets and rip quality.',
    'portal.immortality.step2.note': 'FLAC + LOG',
    'portal.immortality.step3.title': 'Step 3: Eternity',
    'portal.immortality.step3.body': 'After validation, your CD lives in the Digital Sarcophagus (Backblaze B2) and can be played in Grooveflix with a Hi‑Fi aesthetic.',
    'portal.immortality.plansCta': 'Plans',
    'portal.immortality.infobox': 'MVP: Grooveflix UI ships first. Upload automation/validation and the B2→Cloudflare pipeline arrive in the next phase.',
    'grooveflix.badge': 'HI‑FI STREAMING',
    'grooveflix.subtitle': 'The collector’s digital sarcophagus. Hi‑Fi streaming and curation.',
    'grooveflix.loading': 'Loading...',
    'grooveflix.albums': 'albums',
    'grooveflix.rows.continue': 'Continue Listening',
    'grooveflix.rows.recent': 'Newly Immortalized',
    'grooveflix.rows.jp': 'Japanese Pressings',
    'grooveflix.rows.br': 'Forgotten Brazilian Grooves',
    'plans.badge': 'GUARDIANS OF THE SARCOPHAGUS',
    'plans.title': 'Subscriptions',
    'plans.subtitle': 'Choose your Guardian tier to immortalize and listen with a Hi‑Fi aesthetic.',
    'plans.recommended': 'Recommended',
    'plans.preview': 'View Grooveflix',
    'plans.note.title': 'Note',
    'plans.note.body': 'Paid checkout and automated upload validation are next phase. For now, this screen saves the selected plan and unlocks Grooveflix navigation.',
    'plans.saved.title': 'PLAN SELECTED',
    'plans.saved.desc': 'Subscription checkout is the next step.',
    'plans.selectFirst': 'Select a plan to continue.',
    'plans.restricted.badge': 'RESTRICTED ACCESS',
    'plans.restricted.title': 'The Gate Blocks the Sarcophagus',
    'plans.restricted.body': 'To enter Grooveflix, activate a Guardian plan with an active subscription.',
    'plans.restricted.close': 'View Plans',
    'plans.restricted.cta': 'Activate Keeper',
    'plans.digger.title': 'DIGGER',
    'plans.digger.price': 'Free',
    'plans.digger.badge': 'Entry',
    'plans.digger.f1': 'Marketplace access',
    'plans.digger.f2': '5 test immortalizations',
    'plans.digger.f3': 'Personal library (limited)',
    'plans.digger.cta': 'Enter the Groove',
    'plans.keeper.title': 'KEEPER',
    'plans.keeper.price': 'Pro',
    'plans.keeper.badge': 'Silver',
    'plans.keeper.f1': 'Up to 100 CDs immortalized',
    'plans.keeper.f2': 'Hi‑Fi mobile streaming',
    'plans.keeper.f3': 'Silver profile badge',
    'plans.keeper.cta': 'Become Keeper',
    'plans.high.title': 'HIGH GUARDIAN',
    'plans.high.price': 'Elite',
    'plans.high.badge': 'Neon Gold',
    'plans.high.f1': 'Unlimited CDs',
    'plans.high.f2': 'Bit‑perfect streaming',
    'plans.high.f3': 'Access to public community items',
    'plans.high.f4': 'Gold badge with neon glow',
    'plans.high.cta': 'Become Guardian',
    'checkout.subscription.badge': 'GROOVEFLIX CHECKOUT',
    'checkout.subscription.title': 'Finalizing your',
    'checkout.subscription.title2': 'Guardian Ritual',
    'checkout.subscription.subtitle': 'Confirm your plan and complete payment. Once approved, the gate opens the Sarcophagus.',
    'checkout.subscription.planLabel': 'Selected Plan',
    'checkout.subscription.total': 'Total',
    'checkout.subscription.gateway': 'Payment Method',
    'checkout.subscription.cta': 'Confirm and Pay',
    'checkout.subscription.back': 'Back',
    'checkout.subscription.noteTitle': 'Note',
    'checkout.subscription.noteBody': 'Access is released automatically after gateway confirmation. If it takes a few seconds, the system syncs via webhook.',
    'checkout.subscription.success.title': 'PAYMENT CONFIRMED',
    'checkout.subscription.success.desc': 'Unlocking Sarcophagus access...',
    'checkout.subscription.error.title': 'PAYMENT ERROR',
    'checkout.subscription.error.desc': 'Try again.',
    'checkout.subscription.unlocked.badge': 'Access Granted',
    'checkout.subscription.unlocked.badgePending': 'Unlocking...',
    'checkout.subscription.unlocked.badgeFail': 'Sync Pending',
    'checkout.subscription.unlocked.title': 'Sarcophagus',
    'checkout.subscription.unlocked.title2': 'Open',
    'checkout.subscription.unlocked.pendingTitle': 'Access',
    'checkout.subscription.unlocked.pendingTitle2': 'Being Granted',
    'checkout.subscription.unlocked.failTitle': 'Almost there',
    'checkout.subscription.unlocked.desc': 'Your subscription is active. Redirecting to Grooveflix…',
    'checkout.subscription.unlocked.pendingDesc': 'Waiting for final gateway confirmation. This may take a few seconds.',
    'checkout.subscription.unlocked.failDesc': 'Webhook sync is still running. Wait a few seconds and try again.',
    'checkout.subscription.unlocked.cta': 'Enter Grooveflix',
    'checkout.subscription.unlocked.retry': 'Reload',
    'checkout.subscription.unlocked.plans': 'View Plans',
    'portal.terms.lastUpdate': 'Last update: February 12, 2026',
    'portal.terms.warningTitle': '⚠️ LEGAL OBLIGATION:',
    'portal.terms.warningBody': 'By using RAREGROOVE as a seller, you declare that: (1) CDs are original, (2) You have the legal right to sell them, (3) Your descriptions are honest and accurate. False statements result in permanent ban + legal action.',
    'portal.terms.section1.title': '1. Acceptance of Terms',
    'portal.terms.section1.body': 'By accessing and using the RAREGROOVE Marketplace, you agree to be bound by these Terms of Service. If you do not agree with any part of these terms, you are not authorized to use the Service.'
    ,
    'portal.terms.section2.title': '2. Buyer Rights',
    'portal.terms.section2.items.custody': 'Payment custody: Your money stays with RAREGROOVE for up to 7 days — it never goes directly to the seller before confirmation',
    'portal.terms.section2.items.authenticity': 'Authenticity guarantee: If the CD is fake, you receive 100% back without returning',
    'portal.terms.section2.items.condition': 'Condition guarantee: If the condition does not match, you may return within 7 days',
    'portal.terms.section2.items.tracking': 'Mandatory tracking: Every CD ships with tracking and automatic coverage',
    'portal.terms.section2.items.mediation': 'Mediation: If you disagree with the seller, RAREGROOVE arbitrates within a maximum of 16 days',
    'portal.terms.section3.title': '3. Seller Responsibilities',
    'portal.terms.section3.items.scale': 'Describe the REAL condition using Discogs scale (Mint, NM, VG+, VG, Good, Fair)',
    'portal.terms.section3.items.photos': 'Minimum 3 photos: front, back, disc — showing actual condition',
    'portal.terms.section3.items.defects': 'Reveal ALL known defects in the description',
    'portal.terms.section3.items.shippingTime': 'Ship the CD within 2 days after sale confirmation',
    'portal.terms.section3.items.tracking': 'Tracking is mandatory',
    'portal.terms.section3.items.counterfeit': 'Counterfeit CDs = permanent ban + legal action',
    'portal.terms.section4.title': '4. Escrow System',
    'portal.terms.section4.timeline.day1': 'Day 1',
    'portal.terms.section4.timeline.day1.desc': 'Buyer pays via PIX',
    'portal.terms.section4.timeline.days1_3': 'Days 1–3',
    'portal.terms.section4.timeline.days1_3.desc': 'Seller ships CD with tracking',
    'portal.terms.section4.timeline.days4_8': 'Days 4–8',
    'portal.terms.section4.timeline.days4_8.desc': 'Buyer receives the CD',
    'portal.terms.section4.timeline.day8': 'Day 8',
    'portal.terms.section4.timeline.day8.desc': 'Buyer confirms receipt',
    'portal.terms.section4.timeline.days9_10': 'Days 9–10',
    'portal.terms.section4.timeline.days9_10.desc': 'Seller receives the money',
    'portal.terms.section5.title': '5. Dispute Resolution',
    'portal.terms.section5.steps.1': 'Contact the seller via private platform chat (wait 48h)',
    'portal.terms.section5.steps.2': 'If unresolved, open a dispute within 7 days',
    'portal.terms.section5.steps.3': 'Provide evidence: photos, screenshots, tracking',
    'portal.terms.section5.steps.4': 'RAREGROOVE specialist analyzes and arbitrates within 16 days',
    'portal.terms.section5.steps.5': 'Buyers who open multiple false disputes receive a permanent ban',
    'portal.terms.section6.title': '6. Account Termination',
    'portal.terms.section6.lead': 'RAREGROOVE reserves the right to:',
    'portal.terms.section6.items.suspend': 'Suspend accounts for Terms violations',
    'portal.terms.section6.items.retain': 'Hold funds in custody during fraud investigation',
    'portal.terms.section6.items.ban': 'Permanently ban for: counterfeiting, fraud, abuse, DMCA violation',
    'portal.terms.section6.items.report': 'Report criminal activity to competent authorities',
    'portal.terms.section7.title': '7. Final Provisions',
    'portal.terms.section7.body': 'Applicable Law: Laws of the Federative Republic of Brazil. For legal disputes, jurisdiction will be defined as applicable. RAREGROOVE may modify these Terms with prior email communication.'
    ,
    'portal.hero.pill.lgpd': '✓ LGPD Compliant',
    'portal.hero.pill.dmca': '✓ DMCA Compliant',
    'portal.hero.pill.custody': '✓ Secure Custody',
    'portal.hero.pill.cdc': '✓ Brazilian CDC',
    'portal.privacy.lastUpdate': 'Last update: February 12, 2026 — In compliance with Law 13.709/2018 (LGPD)',
    'portal.privacy.section.collect.title': 'Information We Collect',
    'portal.privacy.section.collect.what': 'What we collect',
    'portal.privacy.section.collect.not': 'What we DO NOT collect',
    'portal.privacy.collect.items.nameEmail': 'Name, email and profile data',
    'portal.privacy.collect.items.ip': 'IP address (security and fraud prevention)',
    'portal.privacy.collect.items.timestamps': 'Access timestamps (login/logout)',
    'portal.privacy.collect.items.ua': 'Browser, operating system',
    'portal.privacy.collect.items.history': 'Transaction history on the platform',
    'portal.privacy.collect.not.audio': '❌ Audio file contents',
    'portal.privacy.collect.not.biometric': '❌ Biometric data',
    'portal.privacy.collect.not.browsing': '❌ Off-platform browsing history',
    'portal.privacy.collect.not.selling': '❌ We do not sell data to third parties',
    'portal.privacy.section.share.title': 'Data Sharing',
    'portal.privacy.share.infobox': 'We do not share personal data with third parties, except when required by law (DMCA notices, court orders), with service providers under data protection agreements, or in case of detected criminal activity.',
    'portal.privacy.section.rights.title': 'Your Rights (LGPD)',
    'portal.privacy.rights.items.access': 'Access: Request a copy of your personal data',
    'portal.privacy.rights.items.portability': 'Portability: Receive data in a structured format',
    'portal.privacy.rights.items.delete': 'Deletion: Request deletion of your data (subject to legal retention)',
    'portal.privacy.rights.items.rectify': 'Rectification: Correct inaccurate information',
    'portal.privacy.rights.items.consent': 'Consent withdrawal: At any time',
    'portal.privacy.rights.contactLead': 'To exercise these rights:',
    'portal.privacy.rights.responseTime': 'Response time: 30 business days',
    'portal.privacy.section.security.title': 'Data Security',
    'portal.privacy.security.items.aes': 'AES-256 encryption for data at rest',
    'portal.privacy.security.items.tls': 'TLS 1.3 in transit (encrypted communication)',
    'portal.privacy.security.items.isolation': 'Data isolation between users',
    'portal.privacy.security.items.passwords': 'Passwords with bcrypt hash + unique salt',
    'portal.privacy.security.items.audit': 'Audit data retention for 7 years for legal compliance',
    'portal.community.title': 'Community Policy',
    'portal.community.expected': '✓ Expected Behavior',
    'portal.community.prohibited': '✗ Prohibited Behavior',
    'portal.community.expected.items': 'Be honest in product descriptions;Reply to messages within 24h;Ship with tracking, properly packed;Leave fair and constructive reviews;Resolve disputes collaboratively;Use the platform exclusively for original CDs',
    'portal.community.prohibited.items': 'Describe CDs with false condition;Hide defects in photos;Sell counterfeit CDs as originals;Ask to move off-platform (WhatsApp, direct PIX);Harass or intimidate members;Create fake accounts or falsify data',
    'portal.community.scale.title': 'CD Condition Scale (Discogs)',
    'portal.community.scale.items': 'Mint (M)|Still sealed, never played;Near Mint (NM)|Played a few times, practically new;Very Good Plus (VG+)|Minor signs of use, perfect sound;Very Good (VG)|Signs of play, possible light click;Good (G)|More worn, noticeable clicks but plays;Fair (F)|Heavily used, sound may be affected',
    'portal.community.punishments.title': 'Violation Penalties',
    'portal.community.punishments.items': '🔴 CRITICAL — Permanent Ban|Counterfeit CD, intentional fraud, severe harassment, selling pirated copies;🟠 SERIOUS — Suspension or Ban|Significantly false description, failure to ship after sale, account disappearance;🟡 MINOR — Warning or Short Suspension|Copied photo, shipping delay, slow response, aggressive tone in chat',
    'portal.community.appeal.title': 'Right to Appeal',
    'portal.community.appeal.body': 'If you were unfairly suspended/banned, you may appeal within 30 days by emailing raregroovecdseswapsafe@gmail.com with: your account ID, description of the violation, reason for appeal and evidence.',
    'portal.shipping.title': 'Shipping Policy',
    'portal.shipping.disclaimer.title': 'DISCLAIMER:',
    'portal.shipping.disclaimer.body': 'RAREGROOVE acts exclusively as an intermediary platform. The site DOES NOT participate in logistics, collection or delivery of items. Shipping responsibility is 100% on users involved in the transaction.',
    'portal.shipping.rules.title': 'Shipping Rules',
    'portal.shipping.rules.items': 'Tracking is mandatory for all shipments;Ship within 2 days after sale confirmation;Pack with bubble wrap and rigid corner protection;Mark the box with "FRAGILE" and verticality arrow;Take a photo of the CD before packing (condition proof);Provide tracking code on the platform after shipping',
    'portal.shipping.modalities.title': 'Shipping Modalities (Reference)',
    'portal.shipping.modalities.headers.mode': 'Modality',
    'portal.shipping.modalities.headers.use': 'Suggested Use',
    'portal.shipping.modalities.headers.note': 'Note',
    'portal.shipping.modalities.rows.pac': 'PAC / Economy|Lower value CDs|Valid for printed media',
    'portal.shipping.modalities.rows.sedex': 'SEDEX / Express|High value items|Better handling, safer',
    'portal.shipping.modalities.rows.carrier': 'Carrier|Collections, larger volumes|Better for sensitive covers',
    'portal.shipping.damage.title': 'In case of transport damage',
    'portal.shipping.damage.body': 'Buyer must document (photos/videos) and trigger the insurance of the contracted carrier. RAREGROOVE may suspend accounts with recurring poorly packed shipments. Damage disputes must be opened within 7 days of receipt.',
    'portal.dmca.title': 'DMCA & Copyright',
    'portal.dmca.lastUpdate': 'Last update: February 12, 2026',
    'portal.dmca.intro': 'RAREGROOVE complies with the Digital Millennium Copyright Act (DMCA) of 1998 and similar copyright protection legislation in other jurisdictions.',
    'portal.dmca.user.title': 'User Responsibility',
    'portal.dmca.user.lead': 'RAREGROOVE is not responsible for content uploaded by users. Users are 100% responsible for the content of their accounts. Each user declares that:',
    'portal.dmca.user.items': 'Has legal rights over the content they store;Has original physical copies of any material on the Service;Will not infringe third-party copyrights;Will not use the Service for unauthorized commercial distribution or sharing',
    'portal.dmca.notice.title': 'How to Send a DMCA Notice',
    'portal.dmca.notice.lead': 'Your DMCA notice must contain:',
    'portal.dmca.notice.items': 'Physical or electronic signature of the rights holder;Description of the copyrighted work infringed;Specific URL or exact identification of infringing content;Your name, address, phone and email;Statement under penalty of perjury that you are the authorized rights holder;That the information is accurate and you are authorized to act',
    'portal.dmca.notice.warning': 'Warning: False or malicious notices may result in legal liability under 17 U.S.C. § 512(f).',
    'portal.dmca.response.title': 'Response Times',
    'portal.dmca.response.headers.type': 'Request Type',
    'portal.dmca.response.headers.time': 'Response Time',
    'portal.dmca.response.rows.receipt': 'DMCA notice (receipt)|24 hours',
    'portal.dmca.response.rows.removal': 'Content removal|72 hours (maximum)',
    'portal.dmca.response.rows.counter': 'Counter-notice (receipt)|30 business days',
    'portal.dmca.response.rows.legal': 'Response to legal counsel|As required by law',
    'portal.dmca.policy.title': 'Repeat Infringement Policy',
    'portal.dmca.policy.items': '1st infringement: Email warning + content removal;2nd infringement: 30-day temporary suspension;3rd infringement: Permanent ban + possible legal action'
    ,
    'portal.about.quote': 'RAREGROOVE is the largest rare CDs marketplace in Latin America. We connect collectors, music lovers and traders in a safe, verified and fair way. Finding rarities is easy, and selling your collection is safe.',
    'portal.about.lead': 'RAREGROOVE is a secure peer-to-peer marketplace for buying, selling, and trading rare CDs. We function as reliable intermediaries, offering an escrow system that protects both buyers and sellers in every transaction.',
    'portal.about.how.title': 'How It Works',
    'portal.about.how.items': 'Sign up|Free, takes 2 minutes;Search or list|Search by artist/album or list your collection;Trade safely|Private chat with privacy protection;Secure payment|Your money stays with us until you confirm receipt;Mandatory tracking|Every CD ships with tracking and coverage;Specialized mediation|If there is a problem, our specialists resolve it',
    'portal.about.compare.title': 'RAREGROOVE vs Competition',
    'portal.about.compliance.title': 'Legal Compliance',
    'portal.about.compliance.items': 'Consumer Defense Code (Brazil) — 8.078/1990;LGPD — General Data Protection Law (13.709/2018);DMCA — Digital Millennium Copyright Act (1998);Regulations for custody and financial intermediation services',
    'portal.faq.title': 'Frequently Asked Questions',
    'portal.faq.q1.title': 'Is my money safe on the platform?',
    'portal.faq.q1.body': 'Yes. The escrow system keeps your payment with us until you confirm receipt of the CD in good condition. The seller only gets paid after your confirmation.',
    'portal.faq.q2.title': 'What if the CD doesn’t arrive or is different from the listing?',
    'portal.faq.q2.body': 'You have 7 days after receipt to open a dispute. If the CD doesn’t arrive in 30 days, you receive 100% back. If it’s counterfeit, you receive 100% back without returning.',
    'portal.faq.q3.title': 'How does RAREGROOVE protect my personal data?',
    'portal.faq.q3.body': 'We strictly follow LGPD. Your data is encrypted, never sold to third parties, and you can request deletion at any time. See our Privacy Policy for full details.',
    'portal.faq.q4.title': 'Can I leave the platform to negotiate directly?',
    'portal.faq.q4.body': 'No. Trading off-platform violates our Community Policy and removes all buyer and seller protections. Our integrated chat is secure and keeps history for mediation.',
    'portal.faq.q5.title': 'How do I report a dishonest seller?',
    'portal.faq.q5.body': 'Open a dispute on the platform or email raregroovecdseswapsafe@gmail.com with evidence (photos, screenshots). Our team reviews within up to 16 days.',
    'catalog.title': 'The Catalog',
    'catalog.header': 'Catalog of',
    'catalog.header.gold': 'Relics',
    'catalog.itemsAvailable': 'CDs available for negotiation',
    'catalog.filters.searchLabel': 'Search by Title/Artist',
    'catalog.filters.searchPlaceholder': 'Search a CD...',
    'catalog.filters.genre': 'Genre',
    'catalog.filters.allGenres': 'All Genres',
    'catalog.filters.year': 'Year',
    'catalog.filters.allYears': 'All Years',
    'catalog.filters.yearPlaceholder': 'Ex: 1970',
    'catalog.filters.minPrice': 'Minimum Price',
    'catalog.filters.minPlaceholder': '$ 0',
    'catalog.filters.maxPrice': 'Maximum Price',
    'catalog.filters.maxPlaceholder': '$ 99999',
    'catalog.actions.clearFilters': 'Clear Filters',
    'catalog.actions.addToWishlist': 'Add to Wishlist',
    'catalog.actions.add': 'List Relic',
    'catalog.actions.addedToWishlist': 'Added to wishlist',
    'catalog.actions.removedFromWishlist': 'Removed from wishlist',
    'catalog.empty.title': 'No CDs found',
    'catalog.empty.suggestion': 'Try adjusting the search filters',
    'catalog.empty.noneFound': 'We did not find',
    'catalog.empty.inCollection': 'in our collection',
    'catalog.empty.noResults': 'No Results',
    'catalog.empty.showcaseEmpty': 'Empty Showcase',
    'catalog.empty.searchNoResults': 'No items found for',
    'catalog.empty.noItems': 'This collection has no treasures yet. Be the first to add one!',
    'catalog.empty.loginPrompt': 'Log in to start your collection',
    'grooveflix.reload': 'Reload',
    'grooveflix.upload': 'Upload',
    'grooveflix.filter.all': 'All',
    'grooveflix.empty.title': 'No content found',
    'grooveflix.empty.login': 'Log in to view your content.',
    'grooveflix.empty.upload': 'Upload Grooveflix content to get started.',
    'grooveflix.empty.filter': 'Try changing the category filter.',
    'grooveflix.play': 'Play',
    'grooveflix.noAudio': 'No audio',
    'grooveflix.loadingAlbum': 'Loading album...',
    'grooveflix.playing': 'Playing...',
    'grooveflix.error.noAudio': 'This track has no audio file.',
    'grooveflix.error.load': 'Error loading',
    'grooveflix.tracks': 'tracks',
    'grooveflix.delete.confirm': 'Delete this item?',
    'grooveflix.delete.irreversible': 'This action cannot be undone',
    'grooveflix.delete.action': 'Delete',
    'grooveflix.delete.cancel': 'Cancel',
    'grooveflix.delete.error': 'Error deleting',
    'grooveflix.delete.success': 'Item deleted!',
    'grooveflix.upload.minFiles': 'Select a folder with at least 2 songs',
    'grooveflix.upload.fileTooBig': 'File too big',
    'grooveflix.upload.maxSize': 'Maximum',
    'grooveflix.upload.coverError': 'Error uploading cover',
    'grooveflix.upload.audioError': 'Error uploading audio',
    'grooveflix.upload.generalError': 'Error uploading',
    'grooveflix.upload.titleRequired': 'Fill in title and artist',
    'grooveflix.upload.submit': 'Add to Grooveflix',
    'grooveflix.upload.success': 'CD added to Grooveflix!',
    'grooveflix.upload.updated': 'CD updated successfully!',
    'grooveflix.upload.category.single': 'Single',
    'grooveflix.upload.category.singleDesc': 'A single track',
    'grooveflix.upload.category.album': 'Album',
    'grooveflix.upload.category.albumDesc': 'Folder with all songs',
    'grooveflix.upload.category.compilation': 'Compilation',
    'grooveflix.upload.category.compilationDesc': 'Compilation of tracks',
    'grooveflix.upload.category.isoDesc': 'Full CD (ISO image)',
    'grooveflix.upload.fileType.audio': 'Audio (MP3/FLAC/WAV)',
    'grooveflix.upload.fileType.folder': 'Folder with songs',
    'grooveflix.upload.fileType.preview': 'Preview (optional)',
    'grooveflix.upload.fileType.iso': 'ISO (Full CD)',
    'grooveflix.upload.fileType.booklet': 'Booklet/PDF (optional)',
    'grooveflix.upload.fileType.cover': 'Cover (image)',
    'grooveflix.discogs.searchPlaceholder': 'Ex: Miles Davis Kind of Blue...',
    'grooveflix.discogs.searching': 'Searching...',
    'grooveflix.discogs.search': 'Search',
    'grooveflix.discogs.noResults': 'No results found',
    'grooveflix.discogs.resultsFound': 'results found',
    'grooveflix.discogs.fetchingDetails': 'Loading details...',
    'grooveflix.discogs.fetchError': 'Error fetching details',
    'grooveflix.discogs.importSuccess': 'Data imported from Discogs!',
    'grooveflix.discogs.tracklist': 'Tracklist',
    'grooveflix.discogs.tracks': 'tracks',
    'grooveflix.discogs.moreTracks': '... and more',
    'grooveflix.discogs.format': 'Format',
    'grooveflix.discogs.viewOnDiscogs': 'View on Discogs',
    'grooveflix.discogs.import': 'Import Data',
    'grooveflix.discogs.noResultsQuery': 'No results for',
    'grooveflix.discogs.searchTip': 'Enter a search term to find albums',
    'profile.logout': 'Sign Out',
    'profile.tabs.overview': 'Overview',
    'profile.tabs.addresses': 'My Addresses',
    'profile.tabs.financial': 'Financial',
    'profile.tabs.swaps': 'Swaps',
    'profile.tabs.purchases': 'Purchases',
    'profile.tabs.wishlist': 'Wishlist',
    'profile.tabs.settings': 'Settings',
    'profile.reputation.title': 'Community Reputation',
    'profile.latestReviews': 'Latest Reviews',
    'profile.noComments': 'No comments yet',
    'profile.myListedCds': 'My Listed CDs',
    'profile.viewAll': 'View All',
    'profile.noListed': 'You have not listed any CDs yet.',
    'profile.personalData.title': 'Personal Data',
    'profile.personalData.fullName': 'Full Name',
    'profile.personalData.cpf': 'CPF',
    'profile.personalData.phone': 'Phone',
    'profile.personalData.pix': 'PIX Key',
    'profile.financial.title': 'Financial Dashboard',
    'profile.swaps.title': 'Swap History',
    'profile.swaps.empty': 'You have not made any swaps yet.',
    'profile.purchases.title': 'Purchase History',
    'profile.purchases.empty': 'You have not made any purchases yet.',
    'profile.exploreCatalog': 'Explore Catalog',
    'profile.wishlist.title': 'My Wishlist',
    'profile.wishlist.add': 'Add Wish',
    'profile.settings.title': 'Profile Settings',
    'profile.settings.edit': 'Edit Data',
    'profile.form.notice': '⚠️ These data will be used to generate the shipping labels for CDs.',
    'profile.form.fullNamePlaceholder': 'Your full name',
    'profile.form.address': 'Address (Street/Avenue) *',
    'profile.form.addressPlaceholder': 'Street, Avenue, etc',
    'profile.form.number': 'Number *',
    'profile.form.numberPlaceholder': 'Number or SN',
    'profile.form.complement': 'Complement',
    'profile.form.complementPlaceholder': 'Apt, Block, etc',
    'profile.form.city': 'City *',
    'profile.form.cityPlaceholder': 'Your city',
    'profile.form.state': 'State (UF) *',
    'profile.form.pixKey': 'PIX Key (Email, CPF, Phone or Random Key) *',
    'profile.form.pixKeyPlaceholder': 'Your PIX key to receive payments',
    'profile.form.fetchingAddress': 'Fetching address...',
    'profile.form.dataInfoTitle': '📋 Information about your data:',
    'profile.form.dataInfo.nameCpf': 'Full name and CPF: Used for shipping labels',
    'profile.form.dataInfo.phone': 'Phone: For contact in case of shipping questions',
    'profile.form.dataInfo.address': 'Address: Pickup location if opting for local delivery',
    'profile.form.dataInfo.pixKey': 'PIX Key: To receive payments from sales',
    'profile.form.save': 'Save Data',
    'profile.form.cancel': 'Cancel',
    'profile.addresses.title': 'My Delivery Addresses',
    'profile.addresses.add': 'Add Address',
    'profile.addresses.none': 'No addresses registered',
    'profile.addresses.first': 'Register your first address',
    'profile.addresses.defaultBadge': 'DEFAULT',
    'profile.addresses.btn.edit': 'Edit',
    'profile.addresses.btn.default': 'Make Default',
    'profile.addresses.btn.delete': 'Delete',
    'profile.addresses.modal.edit': 'Edit Address',
    'profile.addresses.modal.new': 'New Address',
    'profile.addresses.modal.label': 'Identify this Address (e.g., Home, Work) *',
    'profile.addresses.modal.labelPlaceholder': 'e.g., Collector\'s House',
    'profile.addresses.modal.name': 'Full Name *',
    'profile.addresses.modal.namePlaceholder': 'Recipient\'s name',
    'profile.addresses.modal.phone': 'Phone',
    'profile.addresses.modal.cep': 'ZIP Code *',
    'profile.addresses.modal.address': 'Address (Street/Avenue) *',
    'profile.addresses.modal.addressPlaceholder': 'Street, Avenue, etc',
    'profile.addresses.modal.number': 'Number *',
    'profile.addresses.modal.numberPlaceholder': 'Number or SN',
    'profile.addresses.modal.complement': 'Complement',
    'profile.addresses.modal.complementPlaceholder': 'Apt, Block, etc',
    'profile.addresses.modal.city': 'City *',
    'profile.addresses.modal.cityPlaceholder': 'Your city',
    'profile.addresses.modal.state': 'State (UF) *',
    'profile.addresses.modal.saving': 'Saving...',
    'profile.addresses.modal.save': 'Save Address',
    'profile.addresses.modal.cancel': 'Cancel'
    ,
    'item.notFound': 'ITEM NOT FOUND',
    'item.notFoundDesc': 'This relic was not found',
    'item.priceLabel': 'MARKET VALUE',
    'item.sellerLabel': 'COLLECTION OF',
    'item.buyAction': 'BUY NOW',
    'item.swapAction': 'PROPOSE SWAP',
    'item.protectedTransaction': 'Transaction Protected by Rare Groove Protocol',
    'item.chatTitle': 'DIRECT NEGOTIATION',
    'item.chatPlaceholder': 'Hello, I am interested in this relic...',
    'item.ownItemError': 'You cannot trade your own item',
    'auth.required': 'Log in to continue',
    'messages.badge': 'Communication',
    'messages.title': 'Messages',
    'messages.subtitle': 'Negotiate within Rare Groove',
    'messages.backToCatalog': 'BACK TO CATALOG',
    'messages.empty': 'No conversations found.'
    ,
    'messagesWithUnread.badge': 'Communication',
    'messagesWithUnread.title': 'Messages',
    'messagesWithUnread.allRead': 'ALL MESSAGES READ',
    'messagesWithUnread.unreadCount': 'UNREAD MESSAGES',
    'messagesWithUnread.tabs.conversations': 'Conversations',
    'messagesWithUnread.tabs.archived': 'Archived',
    'messagesWithUnread.empty': 'Empty around here.',
    'messagesWithUnread.newBadge': 'NEW',
    'messagesWithUnread.backToCatalog': 'BACK TO CATALOG',
    'messagesWithUnread.backToCatalogo': 'BACK TO CATALOG',
    'messagesWithUnread.empty.title': 'NO ACTIVE CONVERSATIONS',
    'messagesWithUnread.empty.desc': 'Your negotiations will appear here once you start a conversation.',
    'messagesWithUnread.empty.archived': 'NO ARCHIVED CONVERSATIONS',
    'messagesWithUnread.empty.archivedDesc': 'Old conversations you archived will appear in this section.',
    'swaps.loading': 'Loading swaps...',
    'swaps.badge': 'Swap System',
    'swaps.title.prefix': 'Guaranteed',
    'swaps.title.highlight': 'Swaps',
    'swaps.subtitle': 'Manage trades with double guarantee and individual confirmations',
    'swaps.backToPortal': 'BACK TO PORTAL',
    'swaps.tabs.list': 'Swap List',
    'swaps.tabs.simulator': 'Simulator',
    'swaps.tabs.create': 'Create Swap',
    'swaps.empty.title': 'No swaps found',
    'swaps.empty.desc': 'There are no trades registered yet.',
    'swaps.createdAt': 'Created on',
    'swaps.completedAt': 'Swap completed on',
    'swaps.confirm.cancel': 'Are you sure you want to cancel this swap?',
    'swaps.alerts.guaranteePaid': 'Guarantee fee paid successfully!',
    'swaps.alerts.receiptConfirmed': 'Receipt confirmed!',
    'swaps.alerts.swapCancelled': 'Swap cancelled successfully',
    'swaps.errors.payment': 'Payment processing error',
    'swaps.errors.confirm': 'Confirmation error',
    'swaps.errors.cancel': 'Cancellation error',
    'swaps.actions.cancel': 'Cancel Swap',
    'swaps.actions.payGuarantee': 'Pay Guarantee Fee',
    'swaps.actions.confirmReceipt': 'Confirm Receipt',
    'swaps.status.waitingOtherParty': 'Waiting for the other party confirmation',
    'swaps.labels.feePaid': 'Fee paid',
    'swaps.labels.feePending': 'Fee pending',
    'swaps.labels.confirmed': 'Confirmed',
    'swaps.labels.condition': 'Condition',
    'swaps.fee.perPerson': 'Fee per person',
    'swaps.fee.totalInCustody': 'Total in custody',
    'swaps.fee.totalRefund': 'Estimated total refund',
    'swaps.fee.individualRefundLabel': 'Individual refund:',
    'swaps.status.proposta_criada': 'Proposal Created',
    'swaps.status.aguardando_checkin': 'Waiting Check-in',
    'swaps.status.checkin_parcial': 'Partial Check-in',
    'swaps.status.etiquetas_liberadas': 'Labels Released',
    'swaps.status.em_transito': 'In Transit',
    'swaps.status.aguardando_confirmacao_recebimento': 'Waiting Confirmation',
    'swaps.status.concluida': 'Completed',
    'swaps.status.sinistro_aberto': 'Claim Open',
    'swaps.status.sinistro_em_analise': 'Claim Under Review',
    'swaps.status.sinistro_resolvido_venda_reversa': 'Claim Resolved',
    'swaps.status.cancelada': 'Cancelled',
    'swaps.status.aguardando_taxas': 'Waiting Fees',
    'swaps.status.autorizado_envio': 'Shipping Authorized',
    'swaps.status.em_troca': 'Trading',
    'swaps.status.concluido': 'Completed',
    'swaps.status.cancelado': 'Cancelled',
    'swaps.simulator.title': 'Swap Simulator',
    'swaps.simulator.guaranteeFeePerPerson': 'Guarantee Fee (per person)',
    'swaps.simulator.portalKeepPct': '% Kept by Portal',
    'swaps.simulator.paymentStatus': 'Payment Status',
    'swaps.simulator.user1Paid': 'User 1 paid the fee',
    'swaps.simulator.user2Paid': 'User 2 paid the fee',
    'swaps.simulator.confirmationStatus': 'Confirmation Status',
    'swaps.simulator.user1Confirmed': 'User 1 confirmed receipt',
    'swaps.simulator.user2Confirmed': 'User 2 confirmed receipt',
    'swaps.simulator.financialCalc': 'Financial Calculations',
    'swaps.simulator.feePerPerson': 'Fee per person',
    'swaps.simulator.totalInCustody': 'Total in custody',
    'swaps.simulator.portalKeeps': 'Portal keeps',
    'swaps.simulator.totalRefund': 'Total refund',
    'swaps.simulator.refundPerPerson': 'Refund per person',
    'swaps.simulator.swapStatus': 'Swap Status',
    'swaps.simulator.bothPaid': 'Both fees paid',
    'swaps.simulator.readyToShip': 'Shipping authorized',
    'swaps.simulator.bothConfirmed': 'Both confirmed receipt',
    'swaps.simulator.completed': 'Swap completed',
    'swaps.simulator.successTitle': 'Swap Completed Successfully!',
    'swaps.simulator.successDescPrefix': 'Each user will receive',
    'swaps.simulator.successDescSuffix': 'as refund',
    'swaps.adminCreate.title': 'Create New Swap (Admin)',
    'swaps.adminCreate.desc': 'Feature in development. Use the chat interface to start swaps between users.',
    'swaps.adminCreate.howItWorks': 'How it works',
    'swaps.adminCreate.steps.1': 'Users negotiate the swap via chat',
    'swaps.adminCreate.steps.2': 'System creates a database record with both items',
    'swaps.adminCreate.steps.3': 'Each user pays the guarantee fee',
    'swaps.adminCreate.steps.4': 'After both pay, they can ship items',
    'swaps.adminCreate.steps.5': 'Each confirms receipt individually',
    'swaps.adminCreate.steps.6': 'System refunds after confirmations',
    'chat.closeDeal': 'Close Deal',
    'chat.processing': 'Processing...',
    'chat.activeTransaction': 'IN NEGOTIATION',
    'catalog.card.value': 'Value',
    'chat.archive': 'Archive',
    'chat.archiving': 'Archiving...',
    'chat.header.talkingTo': 'Talking to',
    'chat.emptyPrompt': 'Start the conversation...',
    'chat.input.placeholder': 'Type your message...',
    'chat.modal.title': 'CONFIRM NEGOTIATION',
    'chat.modal.lead': 'Close this deal',
    'chat.modal.buyerConfirmed': 'Buyer confirmed',
    'paymentSuccess.sold': 'SOLD',
    'checkout.badge': 'SECURE TRANSACTION',
    'checkout.title': 'Complete',
    'checkout.title.gold': 'Acquisition',
    'checkout.subtitle': 'AUTHENTICITY AND SECURITY GUARANTEED',
    'checkout.itemSummary': 'Relic Summary',
    'checkout.paymentMethod': 'Payment Method',
    'checkout.orderSummary': 'Financial Summary',
    'checkout.actions.continue': 'Confirm and Pay',
    'checkout.actions.back': 'Back to selection',
    'checkout.securePayment': '100% Encrypted Payment',
    'checkout.labels.condition': 'Condition',
    'checkout.labels.seller': 'Seller',
    'checkout.labels.itemValue': 'Relic Value',
    'checkout.labels.fee': 'Curatorship Fee',
    'checkout.labels.processing': 'Secure Processing',
    'checkout.labels.total': 'Total Investment',
    'checkout.protection.title': 'RareGroove Protection',
    'checkout.protection.desc': 'Your investment is safe',
    'checkout.payment.creditCard': 'Credit Card',
    'checkout.payment.creditCardDesc': 'Stripe Secure',
    'checkout.payment.mercadoPago': 'Mercado Pago',
    'checkout.payment.mercadoPagoDesc': 'Pix, Boleto and Card',
    'checkout.payment.paypal': 'PayPal',
    'checkout.payment.paypalDesc': 'PayPal Wallet',
    'checkout.success.title': 'Payment Approved',
    'checkout.success.desc': 'Redirecting to vault...',
    'checkout.error.config': 'Configuration Error',
    'checkout.error.noGateway': 'No payment method available at the moment. Contact RareGroove support.'
  }
}

export function I18nProvider({ children, defaultLocale = 'pt-BR' }) {
  const [locale, setLocale] = useState(() => {
    const saved = typeof localStorage !== 'undefined' ? localStorage.getItem('rg_locale') : null
    if (saved) return saved
    const nav = typeof navigator !== 'undefined' ? navigator.language : defaultLocale
    return nav?.startsWith('pt') ? 'pt-BR' : 'en-US'
  })
  const dict = messages[locale] || messages['pt-BR']
  const t = useMemo(() => (key) => dict[key] || key, [dict])
  
  // Estado para armazenar a taxa de câmbio (padrão 5.80)
  const [exchangeRate, setExchangeRate] = useState(5.80);

  // Busca a cotação em tempo real
  useEffect(() => {
    const fetchExchangeRate = async () => {
      try {
        const response = await fetch('https://economia.awesomeapi.com.br/last/USD-BRL');
        const data = await response.json();
        if (data.USDBRL && data.USDBRL.bid) {
          const rate = parseFloat(data.USDBRL.bid);
          if (!isNaN(rate) && rate > 0) {
            setExchangeRate(rate);
          }
        }
      } catch {
        // Mantém o valor padrão em caso de erro
      }
    };

    // Busca ao iniciar
    fetchExchangeRate();

    // Atualiza a cada 5 minutos
    const interval = setInterval(fetchExchangeRate, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const formatCurrency = useMemo(
    () => (value, currency = locale === 'en-US' ? 'USD' : 'BRL') => {
      let finalValue = Number(value || 0);
      
      // Se a moeda desejada for USD e o locale for en-US, converte de BRL para USD
      if (locale === 'en-US') {
        finalValue = finalValue / exchangeRate;
        currency = 'USD';
      }

      return finalValue.toLocaleString(locale, { style: 'currency', currency });
    },
    [locale, exchangeRate]
  )
  const formatDate = useMemo(
    () => (date, options = { day: '2-digit', month: '2-digit', year: '2-digit' }) =>
      new Date(date || Date.now()).toLocaleString(locale, options),
    [locale]
  )
  const safeSetLocale = (next) => {
    setLocale(next)
    try {
      localStorage.setItem('rg_locale', next)
    } catch { void 0 }
  }
  const value = useMemo(() => ({ locale, setLocale: safeSetLocale, t, formatCurrency, formatDate }), [locale, t, formatCurrency, formatDate])
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>
}

export function useI18n() {
  return useContext(I18nContext)
}
